import React, { useState, useEffect } from "react";
import InterventionGame from "../../components/InterventionGame";
import usePractice from "../../hooks/useTopics";
import useGame from "../../hooks/useGame";
import useIntervention from "../../hooks/useIntervention";
import useAppQuestions from "../../hooks/useAppQuestions";
import { navigate } from "@reach/router";
import LoadingScreen from "../../components/LoadingScreen";
import { debug, format } from "util";
import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";
import { promised } from "q";
import LiftSign from "../../assets/Measurements/Images/LiftSign.png";
import WeightOnScale from "../../assets/Measurements/Images/WeightonScale.png";
import AimeeOnScale from "../../assets/Measurements/Images/AimeeonScale.png";
import ScramblerOnScale from "../../assets/Measurements/Images/ScrambleronScale.png";
import EmileOnScale from "../../assets/Measurements/Images/EmileonScale.png";
import GemOnScale from "../../assets/Measurements/Images/GemonScale.png";
import DigClock from "../../assets/Measurements/Images/DigClock.png";
import BottleMeasure1 from "../../assets/Measurements/Images/BottleMeasure1.png";
import BottleMeasure2 from "../../assets/Measurements/Images/BottleMeasure2.png";
import BottleMeasure3 from "../../assets/Measurements/Images/BottleMeasure3.png";
import BottleMeasure4 from "../../assets/Measurements/Images/BottleMeasure4.png";
import BottleMeasure5 from "../../assets/Measurements/Images/BottleMeasure5.png";
import BottleMeasure6 from "../../assets/Measurements/Images/BottleMeasure6.png";
import BottleMeasure7 from "../../assets/Measurements/Images/BottleMeasure7.png";
import BottleMeasure8 from "../../assets/Measurements/Images/BottleMeasure8.png";
import BottleMeasure9 from "../../assets/Measurements/Images/BottleMeasure9.png";
import NewRuler20 from "../../assets/Measurements/Images/NewRuler20.png";
import NewRuler30 from "../../assets/Measurements/Images/NewRuler30.png";
import NewRulerRope from "../../assets/Measurements/Images/NewRulerRope.png";
import NewScale from "../../assets/Measurements/Images/NewScale.png";
import NewScaleDial from "../../assets/Measurements/Images/NewScaleDial.png";
import NewScaleDialSmall from "../../assets/Measurements/Images/NewScaleDialSmall.png";
//IMAGES
import Bar from "../../assets/Statistics/Images/Bar.png";
import BarBar from "../../assets/Statistics/Images/BarBar.png";
import Tally from "../../assets/Statistics/Images/Tally.png";
import TallyLine from "../../assets/Statistics/Images/TallyLine.png";
import TallyStrike from "../../assets/Statistics/Images/TallyStrike.png";
import Tally1 from "../../assets/Statistics/Images/Tally1.png";
import Tally2 from "../../assets/Statistics/Images/Tally2.png";
import Tally3 from "../../assets/Statistics/Images/Tally3.png";
import Tally4 from "../../assets/Statistics/Images/Tally4.png";
import Tally5 from "../../assets/Statistics/Images/Tally5.png";
import Pictograph from "../../assets/Statistics/Images/Pictograph.png";
import LineGraph from "../../assets/Statistics/Images/LineGraph.png";
import Line from "../../assets/Statistics/Images/Line.png";
import TimeTable from "../../assets/Statistics/Images/TimeTable.png";
//animals
import Elephant from "../../assets/Statistics/Images/Elephant.png";
import ElephantHalf from "../../assets/Statistics/Images/ElephantHalf.png";
import Giraffe from "../../assets/Statistics/Images/Giraffe.png";
import GiraffeHalf from "../../assets/Statistics/Images/GiraffeHalf.png";
import Lion from "../../assets/Statistics/Images/Lion.png";
import LionHalf from "../../assets/Statistics/Images/LionHalf.png";
import Zebra from "../../assets/Statistics/Images/Zebra.png";
import ZebraHalf from "../../assets/Statistics/Images/ZebraHalf.png";
//line graphs
import LineGraph1 from "../../assets/Statistics/Images/LineGraph1.png";
import LineGraph2 from "../../assets/Statistics/Images/LineGraph2.png";
import LineGraph3 from "../../assets/Statistics/Images/LineGraph3.png";
import LineGraph4 from "../../assets/Statistics/Images/LineGraph4.png";
//pie charts
import Pie1 from "../../assets/Statistics/Images/Pie1.png";
import Pie2 from "../../assets/Statistics/Images/Pie2.png";
import Pie3 from "../../assets/Statistics/Images/Pie3.png";
import Pie4 from "../../assets/Statistics/Images/Pie4.png";
import Pie5 from "../../assets/Statistics/Images/Pie5.png";
//number sequence
import Sequence from "../../assets/Statistics/Images/Sequence.png";

//const { state: authState } = useAuth();

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function GenerateUniqueRandom(min, max, notthisArray) {
  var returnMe = Math.floor(Math.random() * (max - min) + min);
  console.log(notthisArray)

  if (notthisArray.includes(returnMe)) {
    return GenerateUniqueRandom(min, max, notthisArray);
  }

  return returnMe;
}

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

function RandomPercentageDifference(value, percentMin, percentMax, notthisArray){
  var percent = GenerateRandom(percentMin, percentMax)/100;
  //generate value
  //plus or minus
  var rand = GenerateRandom(1,2);
  if (rand == 1){
      var randomValue = value + (value*percent);
  }else{
      var randomValue = value - (value*percent);
  }
  randomValue = Math.round(randomValue);
  if (notthisArray.includes(randomValue)){
      return RandomPercentageDifference(value,percentMin,percentMax,notthisArray);
  }
  
  return randomValue;
}

/*
function getAnswer(calculation) {
  return 1;
}

function getWrongAnswer(correctAnswer, existingWrongAnswers) {
  return 0;
}
*/

//#region Addition

function ReturnAddition(q) {
  let generatedCalculation = [];
  let calc = q.example_question.replace("  ", " ").split(" ");
  var correctAnswer = "";

  let questionAnswers = [];

  if (calc.length === 4) {
    //N is the random number, rand will return the generation restrictions
    var N = 0;
    var rand = RandomRestrictions(calc[3], "N");

    //Set the calculation to check results for special randoms
    generatedCalculation[0] = 0;
    generatedCalculation[1] = calc[1];
    generatedCalculation[2] = calc[2];

    //Only min/max set
    if (rand[2] == 0)
      N = Math.round(parseInt(rand[1]) + Math.random() * (parseInt(rand[0]) - parseInt(rand[1])));
    //Re-rolls any numbers that require exhange in the calculation
    else if (rand[2] == 1) {
      var temp = 0;
      while (N == 0 || (N.toString()[0] != temp.toString()[0] && !(N.length === 1 && temp.length === 1))) {
        N = Math.round(parseInt(rand[1]) + Math.random() * (parseInt(rand[0]) - parseInt(rand[1])));
        generatedCalculation[0] = N;
        temp = AddgetAnswer(generatedCalculation);
      }
    }
    //Re-roll any numbers that do not require exhange in the calculation
    else if (rand[2] == 2) {
      var temp = 0;
      while (N == 0 || (N.toString()[0] != temp.toString()[0] || N.length != temp.length)) {
        N = Math.round(parseInt(rand[1]) + Math.random() * (parseInt(rand[0]) - parseInt(rand[1])));
        generatedCalculation[0] = N;
        temp = AddgetAnswer(generatedCalculation);
      }
    }

    //Apply the generated number to the question and set the correct answer
    generatedCalculation[0] = N;
    correctAnswer = AddgetAnswer(generatedCalculation);
  }
  //Questions with two variables that need generating
  else if (calc.length === 5) {
    //Number bonds, generates each of the three numbers of the question
    if (calc[2] == "N") {
      var min = 1;
      var max = 10;
      if (calc[4] == "20") {
        min = 11;
        max = 20;
      }
      var total = Math.round(min + Math.random() * (max - min));
      var value1 = Math.round(1 + Math.random() * (total - 1));
      var value2 = total - value1;
      generatedCalculation[0] = "Complete the following number bond, " + total + ": " + value2 + ", ?";
      correctAnswer = value1;
    }
    //Two number calculations covering, large numbers, factors of 10 and decimals
    else {
      //N is first number
      var N = 0;
      var rand = RandomRestrictions(calc[3], "N");

      //Normal number with no special parameters
      if (rand[2] == 0)
        N = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));
      //Decimal numbers
      else if (rand[2] == 4)
        N = Math.round(0.1 + Math.random() * 50) / 100;

      //O is the sceond number
      var O = 0;
      var rand2 = RandomRestrictions(calc[4], "O");

      //Normal number with no special parameters
      if (rand2[2] == 0)
        O = Math.round(rand2[1] + Math.random() * (rand2[0] - rand2[1]));
      //Power of 10
      else if (rand2[2] == 3) {
        var options = [10, 100, 1000, 10000, 100000];
        O = options[Math.floor(Math.random() * options.length - 0.01)]
      }
      //Decimal number
      else if (rand2[2] == 4)
        O = Math.round(Math.random() * (N * 50)) / 100;

      //Set the question parameters
      generatedCalculation[0] = N;
      generatedCalculation[1] = calc[1];
      generatedCalculation[2] = O;

      //Generate the correct answer
      if (calc[1] == "-")
        correctAnswer = N - O;
      else
        correctAnswer = N + O;

        if(correctAnswer.toString().includes("0."))
        {
        correctAnswer = correctAnswer.toFixed(2);

        if(correctAnswer[3] == "0")
        correctAnswer = parseFloat(correctAnswer).toFixed(1);
        }
    }
  }
  //Three part question with three generated variables
  else {
    //N is variable 1
    var N = 0;
    var rand = RandomRestrictions(calc[3], "N");
    N = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));

    //O is variable 2
    var O = 0;
    rand = RandomRestrictions(calc[3], "O");
    O = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));

    //P is variable 3
    var P = 0;
    rand = RandomRestrictions(calc[3], "P");
    P = Math.round(rand[1] + Math.random() * (rand[0] - rand[1]));

    //Build the question
    generatedCalculation[0] = N;
    generatedCalculation[1] = calc[1];
    generatedCalculation[2] = O;
    generatedCalculation[1] = calc[3];
    generatedCalculation[2] = P;

    //Set the correct answer
    correctAnswer = N + O + P;
  }

  //override for numeracy intervention
  if (q.question_key == "addsubQ29") {
    var firstNum = GenerateRandom(11, 99);
    var secondNum = GenerateRandom(11, 99);
    correctAnswer = firstNum + secondNum;
    generatedCalculation = [];
    generatedCalculation.push(firstNum);
    generatedCalculation.push("+");
    generatedCalculation.push(secondNum);
    generatedCalculation.push("=");
    var answersUsed = [];
    answersUsed.push(correctAnswer);
    for (let i = 0; i < 3; i++) {
      let wrong = GenerateUniqueRandom(22, 198, answersUsed);
      console.log(wrong);
      answersUsed.push(wrong);
      questionAnswers.push({
        correct: false,
        value: wrong
      })
    }
  }

  if (q.question_key == "addsubQ31") {
    var firstNum = GenerateRandom(1, 9);
    var secondNum = GenerateRandom(1, 9);
    var thirdNum = GenerateRandom(1,9);
    correctAnswer = firstNum + secondNum + thirdNum;
    generatedCalculation = [];
    generatedCalculation.push(firstNum);
    generatedCalculation.push("+");
    generatedCalculation.push(secondNum);
    generatedCalculation.push("+");
    generatedCalculation.push(thirdNum);
    generatedCalculation.push("=");
    var answersUsed = [];
    answersUsed.push(correctAnswer);
    for (let i = 0; i < 3; i++) {
      let wrong = GenerateUniqueRandom(3, 27, answersUsed);
      console.log(wrong);
      answersUsed.push(wrong);
      questionAnswers.push({
        correct: false,
        value: wrong
      })
    }
  }

  if (q.question_key == "addsubQ34"){//missing number
    var num1 = GenerateRandom(1, 9) * 100;
    var num2 = GenerateRandom(1, 9) * 10;
    var num3 = GenerateRandom(1, 9);

    correctAnswer = num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("+");
    generatedCalculation.push("_");
    generatedCalculation.push("+");
    generatedCalculation.push(num3);
    generatedCalculation.push("=");
    generatedCalculation.push(num1+num2+num3);
    var answersUsed = [];
    answersUsed.push(correctAnswer);
    for (let i = 0; i < 3; i++) {
      let wrong = GenerateUniqueRandom(10, 99, answersUsed);
      console.log(wrong);
      answersUsed.push(wrong);
      questionAnswers.push({
        correct: false,
        value: wrong
      })
    }
  }

  if (q.question_key == "addsubQ35"){//minus 2 digit number from 3 digit number
    var num1 = GenerateRandom(1, 900);
    var num2 = GenerateRandom(1, 90);

    correctAnswer = num1-num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("-");
    generatedCalculation.push(num2);
    generatedCalculation.push("=");
    var answersUsed = [];
    answersUsed.push(correctAnswer);
    for (let i = 0; i < 3; i++) {
      let wrong = GenerateUniqueRandom(50, 900, answersUsed);
      console.log(wrong);
      answersUsed.push(wrong);
      questionAnswers.push({
        correct: false,
        value: wrong
      })
    }
  }

  if (q.question_key == "addsubQ36"){//missing number 2
    var num1 = GenerateRandom(100, 9999);
    var num2 = GenerateRandom(1, 9);

    correctAnswer = num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("-");
    generatedCalculation.push("_");
    generatedCalculation.push("=");
    generatedCalculation.push(num1-num2);
    var answersUsed = [];
    answersUsed.push(correctAnswer);
    for (let i = 0; i < 3; i++) {
      let wrong = GenerateUniqueRandom(10, 99, answersUsed);
      console.log(wrong);
      answersUsed.push(wrong);
      questionAnswers.push({
        correct: false,
        value: wrong
      })
    }
  }

   
  if (q.question_key == "addsubQ37"){//adding multiples of 10
    var num1 = GenerateRandom(100, 9000);
    var num2array = [10,100,1000];
    var num2 = num2array[GenerateRandom(0, num2array.length)];

    correctAnswer = num1+num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("+");
    generatedCalculation.push(num2);
    generatedCalculation.push("=");
    var answersUsed = [];
    answersUsed.push(correctAnswer);
    for (let i = 0; i < 3; i++) {
      let wrong = num1 + GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
      console.log(wrong);
      answersUsed.push(wrong);
      questionAnswers.push({
        correct: false,
        value: wrong
      })
    }
  }

  if (q.question_key == "addsubQ38"){//adding multiples of 10
    var num1 = GenerateRandom(1001, 9000);
    var num2array = [10,100,1000];
    var num2 = num2array[GenerateRandom(0, num2array.length)];

    correctAnswer = num1-num2;

    generatedCalculation = [];
    generatedCalculation.push(num1);
    generatedCalculation.push("-");
    generatedCalculation.push(num2);
    generatedCalculation.push("=");
    var answersUsed = [];
    answersUsed.push(correctAnswer);
    for (let i = 0; i < 3; i++) {
      let wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
      console.log(wrong);
      answersUsed.push(wrong);
      questionAnswers.push({
        correct: false,
        value: wrong
      })
    }
  }

  if (q.question_key == "addsub3Q1"){//numberbonds 10 only
    generatedCalculation = [];
      var total = 10;
      var value1 = Math.round(1 + Math.random() * (total - 1));
      var value2 = total - value1;
      
      correctAnswer = value1;
      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push("?");
      generatedCalculation.push("=");
      generatedCalculation.push(total);
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub3Q2"){//numberbonds 20 only
    generatedCalculation = [];
      var total = 10;
      var value1 = Math.round(1 + Math.random() * (total - 1));
      var value2 = total - value1;
      
      correctAnswer = value1;
      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push("?");
      generatedCalculation.push("=");
      generatedCalculation.push(total);
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q4"){//Adding 1 or 2 to number that requires exchange
    generatedCalculation = [];
      
    var value1array = [9, 19, 29, 39, 49, 59, 69, 79, 89];
    var value1 = value1array[GenerateRandom(0, value1array.length)];

      var value2array = [1,2];
      var value2 = value2array[GenerateRandom(0, value2array.length)];
      
      correctAnswer = value1+value2;

      generatedCalculation.push(value1);
      generatedCalculation.push("+");
      generatedCalculation.push(value2);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q5"){//Subtracting 1, 2, 3, 4 or 5 from numbers less than 10
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,5);
    var value2 = GenerateRandom(value1+1,9);
      
      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q9"){//Adding two single digit numbers that does not require exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,5);
    var value2 = GenerateRandom(1,5);
      
      correctAnswer = value1+value2;

      generatedCalculation.push(value1);
      generatedCalculation.push("+");
      generatedCalculation.push(value2);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q2"){//Adding 1, 2, 3 or 4 to numbers that gives a sum between 11 and 20
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,4);
    var value2 = GenerateRandom(10,15);
      
      correctAnswer = value1+value2;

      generatedCalculation.push(value1);
      generatedCalculation.push("+");
      generatedCalculation.push(value2);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q3"){//Adding a single digit number to numbers less than 100 without needing to exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,8);
    var value2 = 0;

    if(value1 == 1)
    {
      value2= GenerateRandom(20,98);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89)
      {
        value2= GenerateRandom(20,98);
      }
    }
      
    if(value1 == 2)
    {
      value2= GenerateRandom(20,97);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88)
      {
        value2= GenerateRandom(20,97);
      }
    }

    if(value1 == 3)
    {
      value2= GenerateRandom(20,96);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87)
      {
        value2= GenerateRandom(20,96);
      }
    }

    if(value1 == 4)
    {
      value2= GenerateRandom(20,95);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86)
      {
        value2= GenerateRandom(20,95);
      }
    }

    if(value1 == 5)
    {
      value2= GenerateRandom(20,94);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85)
      {
        value2= GenerateRandom(20,94);
      }
    }

    if(value1 == 6)
    {
      value2= GenerateRandom(20,93);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84)
      {
        value2= GenerateRandom(20,93);
      }
    }

    if(value1 == 7)
    {
      value2= GenerateRandom(20,92);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83)
      {
        value2= GenerateRandom(20,92);
      }
    }

    if(value1 == 8)
    {
      value2= GenerateRandom(20,91);

      while(value2 == 29 || value2 == 39 || value2 == 49 || value2 == 59 || value2 == 69 || value2 == 79 || value2 == 89
         || value2 == 28 || value2 == 38 || value2 == 48 || value2 == 58 || value2 == 68 || value2 == 78 || value2 == 88
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82)
      {
        value2= GenerateRandom(20,91);
      }
    }

      correctAnswer = value1+value2;

      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q20"){//Adding a single digit number to numbers that requires exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(3,8);
    var value2 = 0;

    if(value1 == 3)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87];

         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 4)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86]

         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 5)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85]

       value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 6)
    {
     var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85
         , 24 , 34 , 44 , 54 , 64 , 74 , 84]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 7)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85
         , 24 , 34 , 44 , 54 , 64 , 74 , 84
         , 23 , 33 , 43 , 53 , 63 , 73 , 83]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 8)
    {
      var value2array = [29 , 39 , 49 , 59 , 69 , 79 , 89
         , 28 , 38 , 48 , 58 , 68 , 78 , 88
         , 27 , 37 , 47 , 57 , 67 , 77 , 87
         , 26 , 36 , 46 , 56 , 66 , 76 , 86
         , 25 , 35 , 45 , 55 , 65 , 75 , 85
         , 24 , 34 , 44 , 54 , 64 , 74 , 84
         , 23 , 33 , 43 , 53 , 63 , 73 , 83
         , 22 , 32 , 42 , 52 , 62 , 72 , 82]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

      correctAnswer = value1+value2;

      generatedCalculation.push(value2);
      generatedCalculation.push("+");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q6"){ //Subtracting 1, 2, 3 or 4 from numbers more than 10 and less than 19
    generatedCalculation = [];
      
    var value1 = GenerateRandom(1,4);
    var value2 = GenerateRandom(10,18);
      
      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q15"){ //Subtracting a single digit number from numbers less than 100, without needing to exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(2,8);
    var value2 = 0;
 
    if(value1 == 2)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 3)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 4)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 5)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 6)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85 || value2 == 95)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 7)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85 || value2 == 95
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86 || value2 == 96)
      {
        value2= GenerateRandom(20,99);
      }
    }

    if(value1 == 8)
    {
      value2= GenerateRandom(20,99);

      while(value2 == 20 || value2 == 30 || value2 == 40 || value2 == 50 || value2 == 60 || value2 == 70 || value2 == 80 || value2 == 90
         || value2 == 21 || value2 == 31 || value2 == 41 || value2 == 51 || value2 == 61 || value2 == 71 || value2 == 81 || value2 == 91
         || value2 == 22 || value2 == 32 || value2 == 42 || value2 == 52 || value2 == 62 || value2 == 72 || value2 == 82 || value2 == 92
         || value2 == 23 || value2 == 33 || value2 == 43 || value2 == 53 || value2 == 63 || value2 == 73 || value2 == 83 || value2 == 93
         || value2 == 24 || value2 == 34 || value2 == 44 || value2 == 54 || value2 == 64 || value2 == 74 || value2 == 84 || value2 == 94
         || value2 == 25 || value2 == 35 || value2 == 45 || value2 == 55 || value2 == 65 || value2 == 75 || value2 == 85 || value2 == 95
         || value2 == 26 || value2 == 36 || value2 == 46 || value2 == 56 || value2 == 66 || value2 == 76 || value2 == 86 || value2 == 96
         || value2 == 27 || value2 == 37 || value2 == 47 || value2 == 57 || value2 == 67 || value2 == 77 || value2 == 87 || value2 == 97)
      {
        value2= GenerateRandom(20,99);
      }
    }

      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (q.question_key == "addsub2Q16"){ //Subtracting a single digit number from numbers less than 100 that need to exchange
    generatedCalculation = [];
      
    var value1 = GenerateRandom(2,8);
    var value2 = 0;
 
    if(value1 == 2)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 3)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 4)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 5)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 6)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94
         ,25 ,35 ,45 ,55 ,65 ,75 ,85 ,95]
      
      value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 7)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94
         ,25 ,35 ,45 ,55 ,65 ,75 ,85 ,95
         ,26 ,36 ,46 ,56 ,66 ,76 ,86 ,96]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

    if(value1 == 8)
    {
      var value2array = [20 ,30 ,40 ,50 ,60 ,70 ,80 ,90
         ,21 ,31 ,41 ,51 ,61 ,71 ,81 ,91
         ,22 ,32 ,42 ,52 ,62 ,72 ,82 ,92
         ,23 ,33 ,43 ,53 ,63 ,73 ,83 ,93
         ,24 ,34 ,44 ,54 ,64 ,74 ,84 ,94
         ,25 ,35 ,45 ,55 ,65 ,75 ,85 ,95
         ,26 ,36 ,46 ,56 ,66 ,76 ,86 ,96
         ,27 ,37 ,47 ,57 ,67 ,77 ,87 ,97]
      
         value2 = value2array[GenerateRandom(0, value2array.length)];
    }

      correctAnswer = value2-value1;

      generatedCalculation.push(value2);
      generatedCalculation.push("-");
      generatedCalculation.push(value1);
      generatedCalculation.push("=");
      var answersUsed = [];
      answersUsed.push(correctAnswer);
      for (let i = 0; i < 3; i++) {
        let wrong = num1 - GenerateUniqueRandom(1, 9, answersUsed)* num2array[GenerateRandom(0,num2array.length)];
        console.log(wrong);
        answersUsed.push(wrong);
        questionAnswers.push({
          correct: false,
          value: wrong
        })
      }
  }

  if (correctAnswer.toString().indexOf(".") != -1) {
    correctAnswer = parseFloat(correctAnswer).toFixed(2)
  }

  //Add correct answer
  let wrongAnswers = [];
  questionAnswers.push({
    correct: true,
    value: correctAnswer
  });

  if (q.question_key != "addsubQ29" && q.question_key != "addsubQ31" && q.question_key != "addsubQ34" && q.question_key != "addsubQ35" && q.question_key != "addsubQ36" && q.question_key != "addsubQ37" && q.question_key != "addsubQ38"
             && q.question_key != "addsub3Q1" && q.question_key != "addsub3Q2" && q.question_key != "addsub2Q4" && q.question_key != "addsub2Q5" && q.question_key != "addsub2Q9" && q.question_key != "addsub2Q2" && q.question_key != "addsub2Q3"
             && q.question_key != "addsub2Q20" && q.question_key != "addsub2Q6" && q.question_key != "addsub2Q15" && q.question_key != "addsub2Q16"){
    //Generate incorrect answers
    for (var n = 1; n < 4; n++)
    {
      var newIncorrectAnswer = AddgetWrongAnswer(
        correctAnswer,
        wrongAnswers
      );
      wrongAnswers.push(newIncorrectAnswer);
      questionAnswers.push({
        correct: false,
        value: newIncorrectAnswer
      });
    }
  }

  //Mix up answers
  shuffleArray(questionAnswers);

  let questionText = generatedCalculation.join(" ");
  
  let temp2 = [];
  temp2[0] = generatedCalculation;
  temp2[1] = correctAnswer;
  //Creates object to return
  let questionObj = {
    question: questionText,
    answers: questionAnswers,
    correct: correctAnswer,
    topic_id: q.topic_id,
    subject: "addition"
  };
  return questionObj;
}

//Returns the parameters of the random number
function RandomRestrictions(details, split) {
  console.log(details);
  console.log(split);
  let generation = details.split(split);
  var min = 1;
  var max = 100000;
  var cap = 0;
  for (var o = 1; o < generation.length; o++) {
    if (generation[o][0] === "<")
      max = parseInt(generation[o].substring(1));
    else if (generation[o][0] === ">")
      min = parseInt(generation[o].substring(1)) + 1;
    else if (generation[o][0] === "n")
      cap = 1;
    else if (generation[o][0] === "e")
      cap = 2;
    else if (generation[o][0] == "x")
      cap = 3;
    else if (generation[o][0] == "d")
      cap = 4;
  }
  let value = [max, min, cap];
  return value;
}

//Returns correct answer for most cases, other cases are done in line
function AddgetAnswer(calculation) {
  const calculationParts = calculation;

  if (calculationParts.length === 3) {
    const [number1, operator, number2] = calculationParts;

    switch (operator) {
      case "-":
        return parseInt(number1) - parseInt(number2);
      case "+":
        return parseInt(number1) + parseInt(number2);
      default:
        break;
    }
  }
  else
    return 0;
}

//Gets a number within 10 of the correct answer, doesn't return repeat values
function AddgetWrongAnswer(correctAnswer, existingWrongAnswers) {
  //Prep variables
  var output = 0;
  var getAnswer = true;
  //Wierd while loop, decided not to change it as my while loops keep breaking for some reason
  do {
    //Random for normal numbers
    if (correctAnswer > 1)
      output = parseInt(correctAnswer) - 10 + Math.round(Math.random() * 20);
    //Random for decimal numbers
    else
      output = Math.round(Math.random() * 90) / 100;

    getAnswer = false;
    //Repeat if below 0 or the same as the correct answer
    if (output === correctAnswer || output < 0)
      getAnswer = true;
    //Repeat if a duplicate wrong answer
    for (var i = 0; i < existingWrongAnswers.length; i++)
      if (existingWrongAnswers[i] == output)
        getAnswer = true;
  }
  while (getAnswer === true);

  return output;
}
//#endregion

//#region geometry
function ReturnGeometry(q) {

  let questionText = q.question;

  //work out correct answer for each
  let generatedCalculation = 1;
  //set the subject

  //create answers
  let questionAnswers = [];
  let correctAnswer = q.right_answer;
  let wrongAnswers = [];
  questionAnswers.push({
    correct: true,
    value: correctAnswer
  });
  //push all 3 incorrect answers

  wrongAnswers.push({
    correct: false,
    value: q.other_answer_1
  });
  wrongAnswers.push({
    correct: false,
    value: q.other_answer_2
  });
  wrongAnswers.push({
    correct: false,
    value: q.other_answer_3
  });

  questionAnswers.push({
    correct: false,
    value: q.other_answer_1
  });
  questionAnswers.push({
    correct: false,
    value: q.other_answer_2
  });
  questionAnswers.push({
    correct: false,
    value: q.other_answer_3
  });
  //add to list
  let questionObj = {
    question: questionText,
    answers: questionAnswers,
    image: q.image,
    subject: "geometry"
  };
  //RANDOM ANSWER PLACE
  shuffleArray(questionObj.answers);

  return questionObj;
}

function ReturnMeasurements(q) {
  console.log(q);
  var key = q.question_key;
  let imageString;
  let questionAnswers = [];

  let correctAnswerImage = "";
  let correctAnswer = q.right_answer;
  let html = "";
  let questionString = q.question;

  if (q.answer_image == "BottleMeasure" && q.topic_key == "Measurement1") {
    console.log(q);
    correctAnswerImage = "BottleMeasure" + q.right_answer + ".png";
    //push wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: "BottleMeasure" + q.other_answer_1 + ".png"
    });
    questionAnswers.push({
      correct: false,
      value: q.other_answer_2,
      answerImage: "BottleMeasure" + q.other_answer_2 + ".png"
    });
    questionAnswers.push({
      correct: false,
      value: q.other_answer_3,
      answerImage: "BottleMeasure" + q.other_answer_3 + ".png"
    });
  }

  else if (q.question_image_a == "LiftSign" && q.topic_key == "Measurement1") {
    /*
    var imageLine = '<img src= {require"../assets/Measurements/Images/'+q.question_image_a+'.png")}';
    //var imageLine = '<img src=\"'+"../assets/Measurements/Images/"+q.question_image_a+".png"+'\"\">'
    html = imageLine+
    'style={{ position: "relative", top: "-100%", right: "15%" zIndex: "-1"}}></img>'+
  "<div className='centered'>"+1+"</div>"
  //html = ReturnImageDiv();
  html = '<img src={$LiftSign} ></img>'*/
    var liftAnswer = (Math.floor(Math.random() * (20 - 5) + 5));
    correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(5, 20, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer,
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(5, 20, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer,
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(5, 20, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer,
      answerImage: ""
    });

    html = '<img src="' + LiftSign + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:40px ; position:absolute ; top:52% ; right:61%'>" + liftAnswer + "</div>";
  }

  else if (q.question_image_a == "BottleMeasure" && q.topic_key == "Measurement1") {
    //generate correct answer
    var answerNum = Math.floor(Math.random() * (10 - 1) + 1);
    var usedAnswers = [];
    usedAnswers.push(answerNum);
    correctAnswer = answerNum + "L";
    //generate wrong answers
    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "L",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "L",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "L",
      answerImage: ""
    });
    imageString = "BottleMeasure" + answerNum + ".png"
  }

  //LONGEST LINE
  else if (q.answer_image == "LineMeasure" && q.question_key == "Measurement2Q1") {
    var genAnswer = GenerateRandom(7, 10);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "LineMeasure" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(1, 3, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LineMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LineMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LineMeasure" + genAnswer + ".png"
    });
  }
  //LONGEST ROPE

  else if (q.question_key == "Measurement2Q2") {
    var genAnswer = GenerateRandom(7, 10);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "RopeMeasure" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(1, 3, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "RopeMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "RopeMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "RopeMeasure" + genAnswer + ".png"
    });

  }
  //SHORTEST LINE
  else if (q.answer_image == "LineMeasure" && q.question_key == "Measurement2Q3") {
    var genAnswer = GenerateRandom(1, 3);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "LineMeasure" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LineMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LineMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(7, 10, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LineMeasure" + genAnswer + ".png"
    });
  }

  //SHORTEST ROPE

  else if (q.question_key == "Measurement2Q4") {
    var genAnswer = GenerateRandom(1, 3);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "RopeMeasure" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "RopeMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "RopeMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(7, 10, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "RopeMeasure" + genAnswer + ".png"
    });
  }

  //EMILE HEIGHT TALL

  else if (q.question_key == "Measurement2Q5") {
    var genAnswer = GenerateRandom(7, 10);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "EmileHeight" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(1, 3, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "EmileHeight" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "EmileHeight" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "EmileHeight" + genAnswer + ".png"
    });
  }

  //EMILE HEIGHT SHORT

  else if (q.question_key == "Measurement2Q6") {
    var genAnswer = GenerateRandom(1, 3);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "EmileHeight" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "EmileHeight" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "EmileHeight" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(7, 10, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "EmileHeight" + genAnswer + ".png"
    });
  }

  //LADER HEIGHT TALL

  else if (q.question_key == "Measurement2Q7") {
    var genAnswer = GenerateRandom(7, 10);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "LadderMeasure" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(1, 3, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LadderMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LadderMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LadderMeasure" + genAnswer + ".png"
    });
  }

  //LADDER HEIGHT SHORT

  else if (q.question_key == "Measurement2Q8") {
    var genAnswer = GenerateRandom(1, 3);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "LadderMeasure" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LadderMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LadderMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(7, 10, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LadderMeasure" + genAnswer + ".png"
    });
  }

  //How tall is Emile?
  else if (q.question_key == "Measurement3Q1") {
    var height = GenerateRandom(5, 10);
    correctAnswer = height + "cm";
    var usedAnswers = [];
    usedAnswers.push(height);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    imageString = "EmileHeight" + height + ".png"
  }

  //how tall is Scrambler?
  else if (q.question_key == "Measurement3Q2") {
    var height = GenerateRandom(5, 10);
    correctAnswer = height + "cm";
    var usedAnswers = [];
    usedAnswers.push(height);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    imageString = "ScramblerHeight" + height + ".png"
  }

  //HOW LONG IS THE LINE
  else if (q.question_key == "Measurement3Q3") {
    var height = GenerateRandom(5, 10);
    correctAnswer = height + "cm";
    var usedAnswers = [];
    usedAnswers.push(height);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    imageString = "LineMeasure" + height + ".png"
  }

  //HOW LONG IS THE ROPE
  //HOW LONG IS THE LINE
  else if (q.question_key == "Measurement3Q4") {
    var height = GenerateRandom(5, 10);
    correctAnswer = height + "m";
    var usedAnswers = [];
    usedAnswers.push(height);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "m",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "m",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "m",
      answerImage: ""
    });

    imageString = "RopeMeasure" + height + ".png"
  }
  //heavier than 5kg
  else if (q.question_key == "Measurement4Q1") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(6, 10);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 5, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 5, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 5, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET HEAVIEST
    var heaviest = Math.max.apply(null, usedAnswers);
    console.log(heaviest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == heaviest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 84.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + WeightOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:40px ; color:white; position:absolute ; top:9% ; right:" + rightPos + "%'>" + letterArray[i].number + "kg" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //lighter than 5kg
  else if (q.question_key == "Measurement4Q2") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 4);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(5, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(5, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(5, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET HEAVIEST
    var lightest = Math.min.apply(null, usedAnswers);
    console.log(lightest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == lightest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 84.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + WeightOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:40px ; color:white; position:absolute ; top:9% ; right:" + rightPos + "%'>" + letterArray[i].number + "kg" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //heaviest weight
  else if (q.question_key == "Measurement4Q3") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 10);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET HEAVIEST
    var heaviest = Math.max.apply(null, usedAnswers);
    console.log(heaviest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == heaviest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 84.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + WeightOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:40px ; color:white; position:absolute ; top:9% ; right:" + rightPos + "%'>" + letterArray[i].number + "kg" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //lightest weight
  else if (q.question_key == "Measurement4Q4") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 10);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);
    console.log(usedAnswers);

    //GET HEAVIEST
    var heaviest = Math.min.apply(null, usedAnswers);
    console.log(heaviest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == heaviest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 84.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + WeightOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:40px ; color:white; position:absolute ; top:9% ; right:" + rightPos + "%'>" + letterArray[i].number + "kg" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //heaviest weight AIMEE
  else if (q.question_key == "Measurement4Q5") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 10);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET HEAVIEST
    var heaviest = Math.max.apply(null, usedAnswers);
    console.log(heaviest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == heaviest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 84.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + AimeeOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:40px ; color:white; position:absolute ; top:10% ; right:" + rightPos + "%'>" + letterArray[i].number + "kg" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //lightest weight AIMEE
  else if (q.question_key == "Measurement4Q6") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 10);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET HEAVIEST
    var heaviest = Math.min.apply(null, usedAnswers);
    console.log(heaviest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == heaviest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 84.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + AimeeOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:40px ; color:white; position:absolute ; top:10% ; right:" + rightPos + "%'>" + letterArray[i].number + "kg" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  else if (q.question_key == "Measurement4Q7") {
    var liftAnswer = GenerateRandom(1, 10)
    correctAnswer = liftAnswer + "kg";
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    html = '<img src="' + EmileOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:40px ; color: white; position:absolute ; top:15% ; right:39%'>" + liftAnswer + "kg" + "</div>";
  }
  else if (q.question_key == "Measurement4Q8") {
    var liftAnswer = GenerateRandom(1, 10)
    correctAnswer = liftAnswer + "kg";
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    html = '<img src="' + ScramblerOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:40px ; color: white; position:absolute ; top:23% ; right:39%'>" + liftAnswer + "kg" + "</div>";
  }

  else if (q.question_key == "Measurement4Q9") {
    var liftAnswer = GenerateRandom(100, 1000)
    correctAnswer = liftAnswer + "kg";
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 1000, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 1000, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 1000, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    html = '<img src="' + GemOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:24px ; color: white; position:absolute ; top:13% ; right:37%'>" + liftAnswer + "kg" + "</div>";
  }

  else if (q.topic_key == "Measurement5") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: q.other_answer_2,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: q.other_answer_3,
      answerImage: ""
    });

    imageString = q.question_image_a + ".png";

  }

  //earliest time AIMEE
  else if (q.question_key == "Measurement6Q1") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 12);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET EARLIEST
    var earliest = Math.min.apply(null, usedAnswers);
    console.log(earliest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == earliest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 90.5 - minus;
      var rightposRight = 80.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + DigClock + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:50px ; position:absolute ; top:38% ; right:" + rightPos + "%'>" + letterArray[i].number + "</div>" +
        "<div style='font-size:50px ; position:absolute ; top:38% ; right:" + rightposRight + "%'>" + "00" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //latest time AIMEE
  else if (q.question_key == "Measurement6Q2") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 12);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET LATESST
    var earliest = Math.max.apply(null, usedAnswers);
    console.log(earliest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == earliest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 90.5 - minus;
      var rightposRight = 80.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + DigClock + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:50px ; position:absolute ; top:38% ; right:" + rightPos + "%'>" + letterArray[i].number + "</div>" +
        "<div style='font-size:50px ; position:absolute ; top:38% ; right:" + rightposRight + "%'>" + "00" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //clock
  else if (q.topic_key == "Measurement6" && q.question_image_a == "DigClock") {
    var liftAnswer = GenerateRandom(1, 12)
    correctAnswer = liftAnswer + " o'clock";
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });

    html = '<img src="' + DigClock + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; position:absolute ; top:38% ; right:60.5%'>" + liftAnswer + "</div>" +
      "<div style='font-size:50px ; position:absolute ; top:38% ; right:20.5%'>" + "00" + "</div>";
  }

  else if (q.question_key == "Measurement6Q14" || q.question_key == "Measurement6Q15" || q.question_key == "Measurement6Q47") {
    //generate correct answer
    var answerNum = GenerateRandom(1, 12);
    var usedAnswers = [];
    usedAnswers.push(answerNum);
    correctAnswer = answerNum + " o'clock";
    //generate wrong answers
    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    imageString = "Clock" + answerNum + ".png"
  }

  else if ((q.topic_key == "Measurement6" || q.topic_key == "Measurement13") && q.question_image_a == "" && q.answer_image == "") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: q.other_answer_2,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: q.other_answer_3,
      answerImage: ""
    });
  }

  //A GREATER THAN B
  else if (q.question_key == "Measurement7Q1") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    var bottleA = GenerateRandom(6, 10);
    var bottleB = GenerateRandom(1, 5);
    //show image

    ReturnBottleMeasure(bottleB);

    html = '<img src="' + ReturnBottleMeasure(bottleA) + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:90% ; right:72.5%'>" + "A" + "</div>" +
      '<img src="' + ReturnBottleMeasure(bottleB) + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:90% ; right:22.5%'>" + "B" + "</div>"
  }

  //B GREATER THAN A
  else if (q.question_key == "Measurement7Q2") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    var bottleB = GenerateRandom(6, 10);
    var bottleA = GenerateRandom(1, 5);
    //show image

    html = '<img src="' + ReturnBottleMeasure(bottleA) + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:90% ; right:72.5%'>" + "A" + "</div>" +
      '<img src="' + ReturnBottleMeasure(bottleB) + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:90% ; right:22.5%'>" + "B" + "</div>"
  }

  //length of rope
  else if (q.question_key == "Measurement8Q1") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    var RopeA = GenerateRandom(12, 20);
    console.log(RopeA);
    var RopeB = GenerateRandom(25, 30);
    //show image

    html = '<img src="' + NewRuler20 + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewRulerRope + '"' + "style='position:absolute ; right:60% ; transform: scale(1," + (0.37 + ((RopeA - 10) * 0.06)).toString() + ") ; transform-origin: 50% 100%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:72.5%'>" + "A" + "</div>" +

      '<img src="' + NewRuler30 + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewRulerRope + '"' + "style='position:absolute ; right:10% ; transform: scale(1," + (0.37 + ((RopeB - 20) * 0.06)).toString() + ") ; transform-origin: 50% 100%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:22.5%'>" + "B" + "</div>"
  }

  //length of rope
  else if (q.question_key == "Measurement8Q2") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    var RopeA = GenerateRandom(25, 30);
    var RopeB = GenerateRandom(12, 20);
    //show image

    html = '<img src="' + NewRuler20 + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewRulerRope + '"' + "style='position:absolute ; right:60% ; transform: scale(1," + (0.37 + ((RopeA - 20) * 0.06)).toString() + ") ; transform-origin: 50% 100%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:72.5%'>" + "A" + "</div>" +

      '<img src="' + NewRuler30 + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewRulerRope + '"' + "style='position:absolute ; right:10% ; transform: scale(1," + (0.37 + ((RopeB - 10) * 0.06)).toString() + ") ; transform-origin: 50% 100%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:22.5%'>" + "B" + "</div>"
  }

  //emile is $ tall
  else if (q.question_key == "Measurement8Q3") {
    let emile = Math.ceil(GenerateRandom(50, 100) / 10) * 10;
    let ans = emile / 2;

    questionString = q.question.replace("$", emile.toString());
    var usedAnswers = [];
    usedAnswers.push(ans);
    let wrong1 = GenerateUniqueRandom(50, 100, usedAnswers);
    usedAnswers.push(wrong1);
    let wrong2 = GenerateUniqueRandom(50, 100, usedAnswers);
    usedAnswers.push(wrong2);
    let wrong3 = GenerateUniqueRandom(50, 100, usedAnswers);
    usedAnswers.push(wrong3);

    correctAnswer = ans + "cm";
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: wrong1 + "cm",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong2 + "cm",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong3 + "cm",
      answerImage: ""
    });
  }

  //mass A greater than or less than B
  else if (q.question_key == "Measurement9Q1") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    var WeightA = GenerateRandom(1, 5);
    var WeightB = GenerateRandom(6, 10);
    //show image
    var Rotation = -154;

    html = '<img src="' + NewScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewScaleDialSmall + '"' + "style='position:absolute ; right:67% ;  transform:rotate(" + (Rotation + (30.45 * WeightA)).toString() + "deg);  top:46%;  transform-origin: 50% 50%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:72.5%'>" + "A" + "</div>" +

      '<img src="' + NewScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewScaleDialSmall + '"' + "style='position:absolute ; right:16.5% ;  transform:rotate(" + (Rotation + (30.45 * WeightB)).toString() + "deg);  top:46%;  transform-origin: 50% 50%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:22.5%'>" + "B" + "</div>"
  }

  //mass A greater than or less than B
  else if (q.question_key == "Measurement9Q2") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    var WeightA = GenerateRandom(6, 10);
    var WeightB = GenerateRandom(1, 5);
    //show image
    var Rotation = -154;

    html = '<img src="' + NewScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewScaleDialSmall + '"' + "style='position:absolute ; right:67% ;  transform:rotate(" + (Rotation + (30.45 * WeightA)).toString() + "deg);  top:46%;  transform-origin: 50% 50%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:72.5%'>" + "A" + "</div>" +

      '<img src="' + NewScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewScaleDialSmall + '"' + "style='position:absolute ; right:16.5% ;  transform:rotate(" + (Rotation + (30.45 * WeightB)).toString() + "deg);  top:46%;  transform-origin: 50% 50%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:22.5%'>" + "B" + "</div>"
  }

  //emile is $ weigh
  else if (q.question_key == "Measurement9Q3") {
    let emile = GenerateRandom(1, 12);
    let ans = emile * 2;

    questionString = q.question.replace("$", emile.toString());
    var usedAnswers = [];
    usedAnswers.push(ans);
    let wrong1 = GenerateUniqueRandom(2, 24, usedAnswers);
    usedAnswers.push(wrong1);
    let wrong2 = GenerateUniqueRandom(2, 24, usedAnswers);
    usedAnswers.push(wrong2);
    let wrong3 = GenerateUniqueRandom(2, 24, usedAnswers);
    usedAnswers.push(wrong3);

    correctAnswer = ans + "kg";
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: wrong1 + "kg",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong2 + "kg",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong3 + "kg",
      answerImage: ""
    });
  }

  //B GREATER THAN A
  else if (q.question_key == "Measurement10Q1") {
    var bottleB = GenerateRandom(1, 10);
    var bottleA = GenerateRandom(1, 10);
    var sum = bottleA + bottleB
    correctAnswer = sum + "l";
    //wrong answer
    var usedAnswers = [];
    usedAnswers.push(sum);
    //generate wrong answers
    var wrong = GenerateUniqueRandom(2, 20, usedAnswers)
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "l",
      answerImage: ""
    });
    wrong = GenerateUniqueRandom(2, 20, usedAnswers)
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "l",
      answerImage: ""
    });
    wrong = GenerateUniqueRandom(2, 20, usedAnswers)
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "l",
      answerImage: ""
    });

    //show image
    html = '<img src="' + ReturnBottleMeasure(bottleA) + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:80% ; right:72.5%'>" + "A" + "</div>" +
      '<img src="' + ReturnBottleMeasure(bottleB) + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:80% ; right:22.5%'>" + "B" + "</div>"
  }

  //length of rope combine
  else if (q.question_key == "Measurement11Q1") {

    var RopeA = GenerateRandom(11, 20);
    var RopeB = GenerateRandom(11, 20);

    var sum = RopeA + RopeB;
    correctAnswer = sum + "m"
    var usedAnswers = [];
    usedAnswers.push(sum);
    //generate wrong answers
    var wrong = GenerateUniqueRandom(22, 40, usedAnswers);
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "m",
      answerImage: ""
    });
    wrong = GenerateUniqueRandom(22, 40, usedAnswers);
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "m",
      answerImage: ""
    });
    wrong = GenerateUniqueRandom(22, 40, usedAnswers);
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "m",
      answerImage: ""
    });
    //show image
    html = '<img src="' + NewRuler20 + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewRulerRope + '"' + "style='position:absolute ; right:60% ; transform: scale(1," + (0.37 + ((RopeA - 10) * 0.06)).toString() + ") ; transform-origin: 50% 100%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:75% ; right:72.5%'>" + "A" + "</div>" +

      '<img src="' + NewRuler20 + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewRulerRope + '"' + "style='position:absolute ; right:10% ; transform: scale(1," + (0.37 + ((RopeB - 10) * 0.06)).toString() + ") ; transform-origin: 50% 100%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:75% ; right:22.5%'>" + "B" + "</div>"
  }

  //scales combined
  else if (q.question_key == "Measurement12Q1") {

    var WeightA = GenerateRandom(1, 10);
    var WeightB = GenerateRandom(1, 10);

    var sum = WeightA + WeightB;
    correctAnswer = sum + "kg"
    var usedAnswers = [];
    usedAnswers.push(sum);
    //generate wrong answers
    var wrong = GenerateUniqueRandom(2, 20, usedAnswers);
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "kg",
      answerImage: ""
    });
    wrong = GenerateUniqueRandom(2, 20, usedAnswers);
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "kg",
      answerImage: ""
    });
    wrong = GenerateUniqueRandom(2, 20, usedAnswers);
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "kg",
      answerImage: ""
    });
    var Rotation = -154;

    html = '<img src="' + NewScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewScaleDialSmall + '"' + "style='position:absolute ; right:67% ;  transform:rotate(" + (Rotation + (30.45 * WeightA)).toString() + "deg);  top:46%;  transform-origin: 50% 50%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:85% ; right:72.5%'>" + "A" + "</div>" +

      '<img src="' + NewScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewScaleDialSmall + '"' + "style='position:absolute ; right:16.5% ;  transform:rotate(" + (Rotation + (30.45 * WeightB)).toString() + "deg);  top:46%;  transform-origin: 50% 50%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:85% ; right:22.5%'>" + "B" + "</div>"
  }

  else if (q.question_key == "Measurement13Q1") {
    var liftAnswer = GenerateRandom(1, 24)
    var modAnswer;
    if (liftAnswer > 12) {
      modAnswer = (liftAnswer - 12)
    } else {
      modAnswer = liftAnswer;
    }
    correctAnswer = modAnswer + " o'clock";

    var usedAnswers = [];
    usedAnswers.push(modAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });

    html = '<img src="' + DigClock + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; position:absolute ; top:38% ; right:60.5%'>" + liftAnswer + "</div>" +
      "<div style='font-size:50px ; position:absolute ; top:38% ; right:20.5%'>" + "00" + "</div>";
  }

  else if (q.question_key == "Measurement13Q2") {
    //generate correct answer
    var answerNum = GenerateRandom(1, 12);
    var usedAnswers = [];
    usedAnswers.push(answerNum);
    correctAnswer = answerNum + " o'clock";
    //generate wrong answers
    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    imageString = "Clock" + answerNum + ".png"
  }

  else if (q.question_key == "Measurement13Q3") {
    //generate correct answer
    var answerNum = GenerateRandom(1, 12);
    var usedAnswers = [];
    usedAnswers.push(answerNum);
    correctAnswer = answerNum + " o'clock";
    //generate wrong answers
    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    imageString = "RomClock" + answerNum + ".png"
  }

  //how many millimeters are in $ litres
  //what is $ kilometers in meters
  //how many grams
  else if (q.question_image_a == "" && q.question.includes("^") == false && q.question_key != "Measurement24Q1") {

    var split = q.question_image_a_value.split("/");
    console.log(split);

    let emile = GenerateRandom(parseInt(split[0]), parseInt(split[1]));
    let emileDec = 0;

    if (parseFloat(split[2]) < 1) {
      emileDec = GenerateRandom(1, 9) / 10;
      emile = emile + emileDec;
    }

    //round it
    var emileRound = parseFloat(split[2]);
    console.log(emileRound);
    emile = Math.round(emile / emileRound) * emileRound
    console.log(emile);

    //get multiplier
    var mult;


    let ans;
    var divide = false;
    if (q.right_answer.includes("/")) {
      mult = q.right_answer.replace("ImageValue/", "");
      ans = emile / parseInt(mult);
      divide = true;
      console.log("divide");
    }
    else {
      mult = q.right_answer.replace("ImageValue*", "");
      ans = emile * parseInt(mult);
    }


    var wrongSplit = q.other_answer_1.split("/");
    if (q.question_key == "Measurement22Q2") {
      console.log(wrongSplit.length);
    }
    var round;
    if (wrongSplit.length >= 3) {
      round = 1;
    } else {
      round = parseFloat(wrongSplit[2]);
    }

    if (divide)
      console.log(round);

    questionString = q.question.replace("$", emile.toString());
    var usedAnswers = [];
    usedAnswers.push(ans);
    let wrong1 = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
    if (divide == true)
      console.log(wrong1);
    if (parseFloat(split[2]) < 1) {
      emileDec = (GenerateRandom(1, 9) / 10) * mult;
      wrong1 = wrong1 + emileDec;
    }
    wrong1 = Math.round(wrong1 / round) * round
    usedAnswers.push(wrong1);
    let wrong2 = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
    if (parseFloat(split[2]) < 1) {
      emileDec = (GenerateRandom(1, 9) / 10) * mult;
      wrong2 = wrong2 + emileDec;
    }
    wrong2 = Math.round(wrong2 / round) * round
    usedAnswers.push(wrong2);
    let wrong3 = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
    console.log(wrong3);
    if (parseFloat(split[2]) < 1) {
      emileDec = (GenerateRandom(1, 9) / 10) * mult;
      wrong3 = wrong3 + emileDec;
    }
    console.log(wrong3);
    wrong3 = Math.round(wrong3 / round) * round
    usedAnswers.push(wrong3);


    var append = split[3].replace("(", "");
    append = append.replace(")", "");

    correctAnswer = ans + append;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: wrong1 + append,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong2 + append,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong3 + append,
      answerImage: ""
    });
  }


  //How many millilitres are in $ litres ^ millilitres?
  else if (q.question.includes("^") == true && q.question_image_a == "") {
    var split = q.question_image_a_value.split("/");
    console.log(split);

    let emile = GenerateRandom(parseInt(split[0]), parseInt(split[1]));
    let emileDec = 0;

    if (parseFloat(split[2]) < 1) {
      emileDec = GenerateRandom(1, 9) / 10;
      emile = emile + emileDec;
    }
    //NEW ADDITION
    let secondSplit = q.question_image_b_value.split("/");
    let otherValue = GenerateRandom(secondSplit[0], secondSplit[1])
    console.log(otherValue);
    //add new addition to value to create answer

    //round it
    var emileRound = parseFloat(split[2]);
    console.log(emileRound);
    emile = Math.round(emile / emileRound) * emileRound
    console.log(emile);

    //get multiplier
    var mult = q.right_answer.replace("ImageValue*", "");
    let ans = emile * parseInt(mult);
    //add new addition to value to create answer
    ans += otherValue

    var wrongSplit = q.other_answer_1.split("/");
    if (q.question_key == "Measurement22Q2") {
      console.log(wrongSplit.length);
    }
    var round;
    if (wrongSplit.length >= 3) {
      round = 1;
    } else {
      round = parseFloat(wrongSplit[2]);
    }

    questionString = q.question.replace("$", emile.toString());
    var usedAnswers = [];
    usedAnswers.push(ans);
    let wrong1 = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
    if (parseFloat(split[2]) < 1) {
      emileDec = (GenerateRandom(1, 9) / 10) * mult;
      wrong1 = wrong1 + emileDec;
    }
    wrong1 = Math.round(wrong1 / round) * round
    usedAnswers.push(wrong1);
    let wrong2 = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
    if (parseFloat(split[2]) < 1) {
      emileDec = (GenerateRandom(1, 9) / 10) * mult;
      wrong2 = wrong2 + emileDec;
    }
    wrong2 = Math.round(wrong2 / round) * round
    usedAnswers.push(wrong2);
    let wrong3 = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
    console.log(wrong3);
    if (parseFloat(split[2]) < 1) {
      emileDec = (GenerateRandom(1, 9) / 10) * mult;
      console.log(emileDec);
      wrong3 = wrong3 + emileDec;
    }
    console.log(wrong3);
    wrong3 = Math.round(wrong3 / round) * round
    usedAnswers.push(wrong3);



    var append;
    if (split.length >= 4) {
      append = split[3].replace("(", "");
      append = append.replace(")", "");
    }

    questionString = q.question.replace("$", emile.toString());
    questionString = questionString.replace("^", otherValue.toString());


    correctAnswer = ans + append;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: wrong1 + append,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong2 + append,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong3 + append,
      answerImage: ""
    });
  }

  else if (q.question_key == "Measurement23Q1" || q.question_key == "Measurement23Q2" || q.question_key == "Measurement25Q1") {
    imageString = q.question_image_a + ".png";
    let answer;

    if (q.question.includes("$") && q.question.includes("^") && q.question.includes("*") == false && q.question_key != "Measurement25Q1") {
      let valueA = GenerateRandom(1, 10);
      let valueB = GenerateRandom(1, 10);
      answer = valueA * valueB;

      questionString = q.question.replace("$", valueA.toString());
      questionString = questionString.replace("^", valueB.toString());

      var wrongSplit = q.other_answer_1.split("/");

      correctAnswer = answer + "cm²";
      var usedAnswers = [];
      usedAnswers.push(answer);

      for (let i = 0; i < 3; i++) {
        var ans = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
        usedAnswers.push(ans);
        questionAnswers.push({
          correct: false,
          value: ans + "cm²",
          answerImage: ""
        });
      }
    }

    else if (q.question.includes("$") && q.question.includes("^") && q.question.includes("*") == true && q.question_key != "Measurement25Q1") {
      let valueA = GenerateRandom(1, 10);
      let valueB = GenerateRandom(1, 10);
      let valueC = GenerateRandom(1, 10);
      answer = valueA * valueB * valueC;

      questionString = q.question.replace("$", valueA.toString());
      questionString = questionString.replace("^", valueB.toString());
      questionString = questionString.replace("*", valueC.toString());

      var wrongSplit = q.other_answer_1.split("/");

      correctAnswer = answer + "cm³";
      var usedAnswers = [];
      usedAnswers.push(answer);

      for (let i = 0; i < 3; i++) {
        var ans = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
        usedAnswers.push(ans);
        questionAnswers.push({
          correct: false,
          value: ans + "cm³",
          answerImage: ""
        });
      }
    }
    else {
      let valueA = GenerateRandom(1, 10);
      let valueB = GenerateRandom(1, 10);
      answer = (valueA * 2) + (valueB * 2);

      questionString = q.question.replace("$", valueA.toString());
      questionString = questionString.replace("^", valueB.toString());

      var wrongSplit = q.other_answer_1.split("/");

      correctAnswer = answer + "cm";
      var usedAnswers = [];
      usedAnswers.push(answer);

      for (let i = 0; i < 3; i++) {
        var ans = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
        usedAnswers.push(ans);
        questionAnswers.push({
          correct: false,
          value: ans + "cm",
          answerImage: ""
        });
      }

    }
  }

  else if (q.question_key == "Measurement24Q1") {
    var value = GenerateRandom(1, 10);
    questionString = q.question.replace("$", value.toString());
    var answer = value * 0.62;
    correctAnswer = answer.toFixed(2) + " miles";
    var usedAnswers = [];
    usedAnswers.push(answer);
    console.log("HELP")

    var wrongSplit = q.other_answer_1.split("/");

    for (let i = 0; i < 3; i++) {
      var ans = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
      var dec = GenerateRandom(1, 99) / 100
      usedAnswers.push(ans);
      questionAnswers.push({
        correct: false,
        value: (ans + dec).toFixed(2) + " miles",
        answerImage: ""
      });
    }

  }

  questionAnswers.push({
    correct: true,
    value: correctAnswer,
    answerImage: correctAnswerImage
  });

  shuffleArray(questionAnswers);

  let question = {
    question: questionString,
    answers: questionAnswers,
    image: imageString,
    topic_key: q.topic_id,
    questionHTML: html,
    subject: "measurements"
  }


  return question;
}

function ReturnBottleMeasure(number) {
  if (number == 1) {
    return BottleMeasure1;
  }
  if (number == 2) {
    return BottleMeasure2;
  }
  if (number == 3) {
    return BottleMeasure3;
  }
  if (number == 4) {
    return BottleMeasure4;
  }
  if (number == 5) {
    return BottleMeasure5;
  }
  if (number == 6) {
    return BottleMeasure6;
  }
  if (number == 7) {
    return BottleMeasure7;
  }
  if (number == 8) {
    return BottleMeasure8;
  }
  if (number == 9) {
    return BottleMeasure9;
  }
}
//#endregion



function ReturnStats(q) {
  var key = q.question_key;
  let imageString;
  let questionAnswers = [];

  let correctAnswerImage = "";
  let correctAnswer = q.right_answer;
  let html = "";
  let questionString = q.question;

  if (q.topic_key == "Stat1") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      answers.push(GenerateUniqueRandom(1, 10, answers));
    }
    correctAnswer = answers[0];
    for (let i = 1; i < 4; i++) {
      questionAnswers.push({
        correct: false,
        value: answers[i],
        answerImage: ""
      });
    }
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }
    html = '<img src="' + Bar + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:79%'>" + "Zebras" + "</b>" +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:79%'>" + "Lions" + "</b>" +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:79%'>" + "Elephants" + "</b>" +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:79%'>" + "Giraffes" + "</b>";
    var rightPos = 76;
    var rightmodifier = -7;
    for (let i = 0; i < 11; i++) {
      html +=
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
      rightPos += rightmodifier;
    }
    //then have the 3 bars
    var toppos = 70;
    var topModifier = -21;
    var scaleModifier = 0.85;//0.85 per every 1
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      html +=
        //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
        '<img src="' + BarBar + '"' + "style='position:absolute ; right:69%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(orderNumbers[i + 1]) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
      toppos += topModifier;
    }
  }

  if (q.topic_key == "Stat2") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      answers.push(GenerateUniqueRandom(1, 10, answers));
    }
    correctAnswer = answers[0];

    for (let i = 1; i < 4; i++) {
      questionAnswers.push({
        correct: false,
        value: answers[i],
        answerImage: ""
      });
    }

    function ReturnTally(input) {
      if (input == 1)
        return Tally1;
      if (input == 2)
        return Tally2;
      if (input == 3)
        return Tally3;
      if (input == 4)
        return Tally4;
      if (input == 5)
        return Tally5;
    }
    //return matching value
    //this is different than the other one because the image has the labels in the wrong order!
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }
    html = '<img src="' + Tally + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:39%'>" + "Animals" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:76.5%'>" + "Zebras" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:55.5%'>" + "Lions" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:28.5%'>" + "Elephants" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:8%'>" + "Giraffes" + "</b>";
    //then have the tally amounts
    var rightPos = 57;
    var bigPosModifier = -22;
    for (let i = 1; i < orderNumbers.length; i++) {
      console.log(orderNumbers[i]);
      var amount = (ReturnMatchingValue(orderNumbers[i]));
      if (amount < 6) {
        html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
      } else {
        html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
      }

      rightPos += bigPosModifier;
    }
  }

  if (q.topic_key == "Stat3") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      answers.push(GenerateUniqueRandom(1, 10, answers));
    }
    correctAnswer = answers[0];

    for (let i = 1; i < 4; i++) {
      questionAnswers.push({
        correct: false,
        value: answers[i],
        answerImage: ""
      });
    }

    //return matching value
    //this is different than the other one because the image has the labels in the wrong order!
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }
    html = '<img src="' + Tally + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:39%'>" + "Animals" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:76.5%'>" + "Zebras" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:55.5%'>" + "Lions" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:28.5%'>" + "Elephants" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:8%'>" + "Giraffes" + "</b>";

    //then have the tally amounts
    var rightPos = 82;
    var bigPosModifier = -22.2;
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      console.log(orderNumbers[i]);
      var amount = (ReturnMatchingValue(orderNumbers[i + 1]));
      html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

      rightPos += bigPosModifier;
    }
  }

  if (q.topic_key == "Stat4") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      answers.push(GenerateUniqueRandom(1, 10, answers));
    }
    correctAnswer = answers[0];
    for (let i = 1; i < 4; i++) {
      questionAnswers.push({
        correct: false,
        value: answers[i],
        answerImage: ""
      });
    }
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnAnimal(input) {
      if (input == 0)
        return Zebra;
      if (input == 0.5)
        return ZebraHalf;
      if (input == 1)
        return Lion;
      if (input == 1.5)
        return LionHalf;
      if (input == 2)
        return Elephant;
      if (input == 2.5)
        return ElephantHalf;
      if (input == 3)
        return Giraffe;
      if (input == 3.5)
        return GiraffeHalf;


    }
    html = '<img src="' + Pictograph + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
      '<img src="' + Zebra + '"' + "style='position:absolute ; top:70%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + Lion + '"' + "style='position:absolute ; top:50%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + Elephant + '"' + "style='position:absolute ; top:30%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + Giraffe + '"' + "style='position:absolute ; top:10%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + GiraffeHalf + '"' + "style='position:absolute ; top:40%; right:16%; transform: scale(1.5,1.5);  zIndex:-1'" + '></img>' +
      "<b style='font-size:30px ; color:#815B37FF ; position:absolute ; top:42%; right:8%;  zIndex:-1'> = 1 </b>"

    var rightPos = 76;
    var rightmodifier = -7;

    //then have the 3 bars
    var toppos = 71;
    var topModifier = -20.5;
    var scaleModifier = 0.85;//0.85 per every 1
    var rightPos = 69;
    var rightModifier = -10;
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      var amount = ReturnMatchingValue(orderNumbers[i + 1]);
      if (i == 1 || i == 2) {
        rightPos = 69;
      } else {
        rightPos = 72;
      }

      //spawn amount of animals equal to the number, if number is odd then end with a half
      amount = amount / 2;
      console.log(amount);

      for (let z = 0; z < amount; z++) {
        if (Number.isInteger(amount) == false && amount - 0.5 == z) {
          html += '<img src="' + ReturnAnimal(i + 0.5) + '"' + "style='position:absolute ; top:" + (toppos - 1) + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        }
        else {
          html += '<img src="' + ReturnAnimal(i) + '"' + "style='position:absolute ; top:" + toppos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        }

        rightPos += rightModifier;
      }

      //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
      //'<img src="' + BarBar + '"' + "style='position:absolute ; right:69%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(orderNumbers[i + 1]) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
      toppos += topModifier;
    }
  }

  if (q.topic_key == "Stat5") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      answers.push(GenerateUniqueRandom(1, 10, answers));
    }
    correctAnswer = answers[0] * q.increments;
    for (let i = 1; i < 4; i++) {
      questionAnswers.push({
        correct: false,
        value: answers[i] * q.increments,
        answerImage: ""
      });
    }
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnAnimal(input) {
      if (input == 0)
        return Zebra;
      if (input == 0.5)
        return ZebraHalf;
      if (input == 1)
        return Lion;
      if (input == 1.5)
        return LionHalf;
      if (input == 2)
        return Elephant;
      if (input == 2.5)
        return ElephantHalf;
      if (input == 3)
        return Giraffe;
      if (input == 3.5)
        return GiraffeHalf;


    }
    html = '<img src="' + Pictograph + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
      '<img src="' + Zebra + '"' + "style='position:absolute ; top:70%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + Lion + '"' + "style='position:absolute ; top:50%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + Elephant + '"' + "style='position:absolute ; top:30%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + Giraffe + '"' + "style='position:absolute ; top:10%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
      '<img src="' + GiraffeHalf + '"' + "style='position:absolute ; top:40%; right:18%; transform: scale(1.5,1.5);  zIndex:-1'" + '></img>' +
      "<b style='font-size:30px ; color:#815B37FF ; position:absolute ; top:42%; right:8%;  zIndex:-1'>= " + q.increments + "</b>"

    var rightPos = 76;
    var rightmodifier = -7;

    //then have the 3 bars
    var toppos = 71;
    var topModifier = -20.5;
    var scaleModifier = 0.85;//0.85 per every 1
    var rightPos = 69;
    var rightModifier = -10;
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      var amount = ReturnMatchingValue(orderNumbers[i + 1]);
      if (i == 1 || i == 2) {
        rightPos = 69;
      } else {
        rightPos = 72;
      }

      //spawn amount of animals equal to the number, if number is odd then end with a half
      amount = amount / 2;
      console.log(amount);

      for (let z = 0; z < amount; z++) {
        if (Number.isInteger(amount) == false && amount - 0.5 == z) {
          html += '<img src="' + ReturnAnimal(i + 0.5) + '"' + "style='position:absolute ; top:" + (toppos - 1) + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        }
        else {
          html += '<img src="' + ReturnAnimal(i) + '"' + "style='position:absolute ; top:" + toppos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
        }

        rightPos += rightModifier;
      }
      toppos += topModifier;
    }
  }

  if (q.topic_key == "Stat6") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      answers.push(GenerateUniqueRandom(1, 10, answers));
    }



    if (orderNumbers[0] == "Picto") {
      var sum = 0;
      for (let i = 0; i < answers.length; i++) {
        sum += (answers[i] * q.increments)
      }
      correctAnswer = sum;
    }
    else {
      var sum = 0;
      for (let i = 0; i < answers.length; i++) {
        sum += (answers[i])
      }
      correctAnswer = sum;
    }

    var answersUsed = [];
    answersUsed.push(correctAnswer);

    for (let i = 1; i < 4; i++) {
      var ans = GenerateUniqueRandom(1, 40, answersUsed)
      answersUsed.push(ans);
      questionAnswers.push({
        correct: false,
        value: ans,
        answerImage: ""
      });
    }


    //return matching value
    function ReturnMatchingValue(input) {
      input = input - 4;
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnAnimal(input) {
      if (input == 0)
        return Zebra;
      if (input == 0.5)
        return ZebraHalf;
      if (input == 1)
        return Lion;
      if (input == 1.5)
        return LionHalf;
      if (input == 2)
        return Elephant;
      if (input == 2.5)
        return ElephantHalf;
      if (input == 3)
        return Giraffe;
      if (input == 3.5)
        return GiraffeHalf;
    }

    function ReturnTally(input) {
      if (input == 1)
        return Tally1;
      if (input == 2)
        return Tally2;
      if (input == 3)
        return Tally3;
      if (input == 4)
        return Tally4;
      if (input == 5)
        return Tally5;
    }
    //THIS IS FOR PICTOGRAPH
    if (orderNumbers[0] == "Picto") {
      html = '<img src="' + Pictograph + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
        '<img src="' + Zebra + '"' + "style='position:absolute ; top:70%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + Lion + '"' + "style='position:absolute ; top:50%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + Elephant + '"' + "style='position:absolute ; top:30%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + Giraffe + '"' + "style='position:absolute ; top:10%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + GiraffeHalf + '"' + "style='position:absolute ; top:40%; right:18%; transform: scale(1.5,1.5);  zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF ; position:absolute ; top:42%; right:8%;  zIndex:-1'>= " + q.increments + "</b>"

      var rightPos = 76;
      var rightmodifier = -7;

      //then have the 3 bars
      var toppos = 71;
      var topModifier = -20.5;
      var scaleModifier = 0.85;//0.85 per every 1
      var rightPos = 69;
      var rightModifier = -10;
      for (let i = 0; i < orderNumbers.length - 1; i++) {
        var amount = ReturnMatchingValue(orderNumbers[i + 1]);
        if (i == 1 || i == 2) {
          rightPos = 69;
        } else {
          rightPos = 72;
        }

        //spawn amount of animals equal to the number, if number is odd then end with a half
        amount = amount / 2;
        console.log(amount);

        for (let z = 0; z < amount; z++) {
          if (Number.isInteger(amount) == false && amount - 0.5 == z) {
            html += '<img src="' + ReturnAnimal(i + 0.5) + '"' + "style='position:absolute ; top:" + (toppos - 1) + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
          }
          else {
            html += '<img src="' + ReturnAnimal(i) + '"' + "style='position:absolute ; top:" + toppos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
          }

          rightPos += rightModifier;
        }
        toppos += topModifier;
      }
    }
    //THIS IS FOR BAR GRAPH
    else if (orderNumbers[0] == "Bar") {
      html = '<img src="' + Bar + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:79%'>" + "Zebras" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:79%'>" + "Lions" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:79%'>" + "Elephants" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:79%'>" + "Giraffes" + "</b>";
      var rightPos = 76;
      var rightmodifier = -7;
      for (let i = 0; i < 11; i++) {
        html +=
          "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
        rightPos += rightmodifier;
      }
      //then have the 3 bars
      var toppos = 70;
      var topModifier = -21;
      var scaleModifier = 0.85;//0.85 per every 1
      for (let i = 0; i < orderNumbers.length - 1; i++) {
        html +=
          //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
          '<img src="' + BarBar + '"' + "style='position:absolute ; right:69%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(orderNumbers[i + 1]) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
        toppos += topModifier;
      }
    }
    //THIS IS FOR TALLY
    else if (orderNumbers[0] == "Tally") {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:39%'>" + "Animals" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:76.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:55.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:28.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:8%'>" + "Giraffes" + "</b>";
      //then have the tally amounts
      var rightPos = 57;
      var bigPosModifier = -22;
      for (let i = 1; i < orderNumbers.length; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(orderNumbers[i]));
        if (amount < 6) {
          html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        } else {
          html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
          html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        }
        rightPos += bigPosModifier;
      }

    }
    //THIS IS FOR TABLE
    else {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:39%'>" + "Animals" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:76.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:55.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:28.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:8%'>" + "Giraffes" + "</b>";

      //then have the table amounts
      var rightPos = 82;
      var bigPosModifier = -22.2;
      for (let i = 0; i < orderNumbers.length - 1; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(orderNumbers[i + 1]));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }
  }

  //SUBTRACTION
  if (q.topic_key == "Stat7") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    var ansvalues = [];
    ansvalues.push(q.answer_5);
    ansvalues.push(q.answer_6);
    ansvalues.push(q.answer_7);
    ansvalues.push(q.answer_8);
    console.log(ansvalues);

    for (let i = 0; i < 4; i++) {
      var genRange = ansvalues[i].split("|");
      var genRange = genRange[1].split(".");
      console.log(genRange);
      answers.push(GenerateRandom(parseInt(genRange[0]), parseInt(genRange[1])));
    }
    console.log(answers);

    var answerSplit = q.answer_1.split("|");
    if (answerSplit[1] == "6.5") {
      //lions minus zebraas
      correctAnswer = answers[1] - answers[0];
    } else if (answerSplit[1] == "7.8") {
      //elphants minus giraffes
      correctAnswer = answers[2] - answers[3];
    }

    var answersUsed = [];
    answersUsed.push(correctAnswer);

    for (let i = 1; i < 4; i++) {
      var ans = GenerateUniqueRandom(1, 10, answersUsed)
      answersUsed.push(ans);
      questionAnswers.push({
        correct: false,
        value: ans,
        answerImage: ""
      });
    }


    //return matching value
    function ReturnMatchingValue(input) {
      input = input - 4;
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnAnimal(input) {
      if (input == 0)
        return Zebra;
      if (input == 0.5)
        return ZebraHalf;
      if (input == 1)
        return Lion;
      if (input == 1.5)
        return LionHalf;
      if (input == 2)
        return Elephant;
      if (input == 2.5)
        return ElephantHalf;
      if (input == 3)
        return Giraffe;
      if (input == 3.5)
        return GiraffeHalf;
    }

    function ReturnTally(input) {
      if (input == 1)
        return Tally1;
      if (input == 2)
        return Tally2;
      if (input == 3)
        return Tally3;
      if (input == 4)
        return Tally4;
      if (input == 5)
        return Tally5;
    }
    //THIS IS FOR PICTOGRAPH
    if (orderNumbers[0] == "Picto") {
      html = '<img src="' + Pictograph + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
        '<img src="' + Zebra + '"' + "style='position:absolute ; top:70%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + Lion + '"' + "style='position:absolute ; top:50%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + Elephant + '"' + "style='position:absolute ; top:30%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + Giraffe + '"' + "style='position:absolute ; top:10%; right:82%; transform: scale(1,1);  zIndex:-1'" + '></img>' +
        '<img src="' + GiraffeHalf + '"' + "style='position:absolute ; top:40%; right:18%; transform: scale(1.5,1.5);  zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF ; position:absolute ; top:42%; right:8%;  zIndex:-1'>= " + q.increments + "</b>"

      var rightPos = 76;
      var rightmodifier = -7;

      //then have the 3 bars
      var toppos = 71;
      var topModifier = -20.5;
      var scaleModifier = 0.85;//0.85 per every 1
      var rightPos = 69;
      var rightModifier = -10;
      for (let i = 0; i < orderNumbers.length - 1; i++) {
        var amount = ReturnMatchingValue(orderNumbers[i + 1]);
        if (i == 1 || i == 2) {
          rightPos = 69;
        } else {
          rightPos = 72;
        }

        //spawn amount of animals equal to the number, if number is odd then end with a half
        amount = amount / 2;
        console.log(amount);

        for (let z = 0; z < amount; z++) {
          if (Number.isInteger(amount) == false && amount - 0.5 == z) {
            html += '<img src="' + ReturnAnimal(i + 0.5) + '"' + "style='position:absolute ; top:" + (toppos - 1) + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
          }
          else {
            html += '<img src="' + ReturnAnimal(i) + '"' + "style='position:absolute ; top:" + toppos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '></img>'
          }

          rightPos += rightModifier;
        }
        toppos += topModifier;
      }
    }
    //THIS IS FOR BAR GRAPH
    else if (orderNumbers[0] == "Bar") {
      html = '<img src="' + Bar + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:82%'>" + "Animals" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:79%'>" + "Zebras" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:79%'>" + "Lions" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:79%'>" + "Elephants" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:79%'>" + "Giraffes" + "</b>";
      var rightPos = 76;
      var rightmodifier = -7;
      for (let i = 0; i < 11; i++) {
        html +=
          "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
        rightPos += rightmodifier;
      }
      //then have the 3 bars
      var toppos = 70;
      var topModifier = -21;
      var scaleModifier = 0.85;//0.85 per every 1
      for (let i = 0; i < orderNumbers.length - 1; i++) {
        html +=
          //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
          '<img src="' + BarBar + '"' + "style='position:absolute ; right:69%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(orderNumbers[i + 1]) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
        toppos += topModifier;
      }
    }
    //THIS IS FOR TALLY
    else if (orderNumbers[0] == "Tally") {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:39%'>" + "Animals" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:76.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:55.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:28.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:8%'>" + "Giraffes" + "</b>";
      //then have the tally amounts
      var rightPos = 57;
      var bigPosModifier = -22;
      for (let i = 1; i < orderNumbers.length; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(orderNumbers[i]));
        if (amount < 6) {
          html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        } else {
          html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
          html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        }
        rightPos += bigPosModifier;
      }

    }
    //THIS IS FOR TABLE
    else {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:39%'>" + "Animals" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:76.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:55.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:28.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:8%'>" + "Giraffes" + "</b>";

      //then have the table amounts
      var rightPos = 82;
      var bigPosModifier = -22.2;
      for (let i = 0; i < orderNumbers.length - 1; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(orderNumbers[i + 1]));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }
  }

  if (q.topic_key == "Stat8") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    answers.push(q.answer_1);
    answers.push(q.answer_2);
    answers.push(q.answer_3);
    answers.push(q.answer_4);

    correctAnswer = answers[0] + "m";

    questionAnswers.push({
      correct: false,
      value: answers[1] + "m",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[2] + "m",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[3] + "m",
      answerImage: ""
    });
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }
    html = '<img src="' + LineGraph + '"' + "style='position:relative  ; right:0% ; zIndex:-1'" + '></img>';
  }

  if (q.topic_key == "Stat9") {
    //this is the order to which is correct
    var graphId = GenerateRandom(1, 4);
    var temps = [,];
    var miniTemp = [];

    if (graphId == 1) {
      miniTemp.push(0);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }
    if (graphId == 2) {
      miniTemp.push(0);
      miniTemp.push(20);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(10);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }
    if (graphId == 3) {
      miniTemp.push(0);
      miniTemp.push(10);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }
    if (graphId == 4) {
      miniTemp.push(0);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(30);
      miniTemp.push(50);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }

    console.log(q);
    console.log(temps);
    if (q.answer_1 == "sum|5.9") {
      correctAnswer = temps[1][0] + temps[1][1];
    }
    if (q.answer_1 == "sum|6.10") {
      correctAnswer = temps[2][0] + temps[2][1];
    }
    if (q.answer_1 == "sum|7.11") {
      correctAnswer = temps[3][0] + temps[3][1];
    }
    if (q.answer_1 == "sum|8.12") {
      correctAnswer = temps[4][0] + temps[4][1];
    }

    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    var ansvalues = [];
    ansvalues.push(q.answer_5);
    ansvalues.push(q.answer_6);
    ansvalues.push(q.answer_7);
    ansvalues.push(q.answer_8);

    answers.push(correctAnswer);
    for (let i = 0; i < 4; i++) {
      var genRange = ansvalues[i].split("|");
      var genRange = genRange[1].split(".");
      answers.push(GenerateRandom(parseInt(genRange[0]), parseInt(genRange[1])) * q.increments);
    }

    correctAnswer += "°C"
    questionAnswers.push({
      correct: false,
      value: answers[1] + "°C",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[2] + "°C",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[3] + "°C",
      answerImage: ""
    });
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnLineGraph() {
      if (graphId == 1)
        return LineGraph1;
      if (graphId == 2)
        return LineGraph2;
      if (graphId == 3)
        return LineGraph3;
      if (graphId == 4)
        return LineGraph4;
    }

    html = '<img src="' + ReturnLineGraph() + '"' + "style='position:relative ; transform: scale(0.8,0.8) ; right:0% ; zIndex:-1'" + '></img>';
  }

  if (q.topic_key == "Stat10") {
    //this is the order to which is correct
    var graphId = GenerateRandom(1, 4);
    var temps = [,];
    var miniTemp = [];

    if (graphId == 1) {
      miniTemp.push(0);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }
    if (graphId == 2) {
      miniTemp.push(0);
      miniTemp.push(20);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(10);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }
    if (graphId == 3) {
      miniTemp.push(0);
      miniTemp.push(10);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(40);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }
    if (graphId == 4) {
      miniTemp.push(0);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(20);
      miniTemp.push(30);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(30);
      miniTemp.push(50);
      temps.push(miniTemp);
      miniTemp = [];
      miniTemp.push(40);
      miniTemp.push(50);
      temps.push(miniTemp);
    }

    console.log(q);
    console.log(temps);
    if (q.answer_1 == "subtract|5.9") {
      console.log(Math.abs(5, 9));
      correctAnswer = Math.abs(temps[1][0] - temps[1][1]);
    }
    if (q.answer_1 == "subtract|6.10") {
      correctAnswer = Math.abs(temps[2][0] - temps[2][1]);
    }
    if (q.answer_1 == "subtract|7.11") {
      correctAnswer = Math.abs(temps[3][0] - temps[3][1]);
    }
    if (q.answer_1 == "subtract|8.12") {
      correctAnswer = Math.abs(temps[4][0] - temps[4][1]);
    }

    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];
    var ansvalues = [];
    ansvalues.push(q.answer_5);
    ansvalues.push(q.answer_6);
    ansvalues.push(q.answer_7);
    ansvalues.push(q.answer_8);

    answers.push(correctAnswer);
    for (let i = 0; i < 4; i++) {
      var genRange = ansvalues[i].split("|");
      var genRange = genRange[1].split(".");
      answers.push(GenerateRandom(parseInt(genRange[0]), parseInt(genRange[1])) * q.increments);
    }

    correctAnswer += "°C"
    questionAnswers.push({
      correct: false,
      value: answers[1] + "°C",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[2] + "°C",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[3] + "°C",
      answerImage: ""
    });
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnLineGraph() {
      if (graphId == 1)
        return LineGraph1;
      if (graphId == 2)
        return LineGraph2;
      if (graphId == 3)
        return LineGraph3;
      if (graphId == 4)
        return LineGraph4;
    }

    html = '<img src="' + ReturnLineGraph() + '"' + "style='position:relative ; transform: scale(0.8,0.8) ; right:0% ; zIndex:-1'" + '></img>';
  }


  if (q.topic_key == "Stat11") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");

    var answers = [];
    var ansvalues = [];
    ansvalues.push(q.answer_1);
    ansvalues.push(q.answer_2);
    ansvalues.push(q.answer_3);
    ansvalues.push(q.answer_4);
    console.log(ansvalues);

    function ConvertToTime(hours, minutes) {
      return hours + ":" + minutes;
    }

    ///tomorrow add the unique random of these above
    //randomise which order it is displayed in

    //sets random times for 4 of the fields
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      var genRange = ansvalues[i].split("|");
      var genRange = genRange[1].split(".");
      console.log(genRange);
      var hours = parseInt(GenerateRandom(parseInt(genRange[0]), parseInt(genRange[1])));
      var minutes = "00";
      if (Math.random() > 0.5) {
        minutes = "30";
      }
      answers.push(ConvertToTime(hours, minutes));
    }
    //do it again for the other fields
    ansvalues = [];
    ansvalues.push(q.answer_5);
    ansvalues.push(q.answer_6);
    ansvalues.push(q.answer_7);
    ansvalues.push(q.answer_8);
    //random again
    for (let i = 0; i < orderNumbers.length - 1; i++) {
      var genRange = ansvalues[i].split("|");
      var genRange = genRange[1].split(".");
      console.log(genRange);
      var hours = parseInt(GenerateRandom(parseInt(genRange[0]), parseInt(genRange[1])));
      var minutes = "00";
      if (Math.random() > 0.5) {
        minutes = "30";
      }
      answers.push(ConvertToTime(hours, minutes));
    }
    //for answers teh id 0-3 is equal to 1-4 on the graph
    //4-7 is equal to 5 to 8 on the graph

    //the order it appears in is to do with the question

    correctAnswer = answers[0];

    for (let i = 1; i < 4; i++) {
      questionAnswers.push({
        correct: false,
        value: answers[i],
        answerImage: ""
      });
    }


    //return matching value
    //this is different than the other one because the image has the labels in the wrong order!
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }
    html = '<img src="' + TimeTable + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:40px ; color:#815B37FF; position:absolute ; top:8% ; right:29.5%'>" + "Zoo Schedule" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:32% ; right:61.5%'>" + "Arriving" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:32% ; right:43.5%'>" + "Feeding" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:32% ; right:25%'>" + "Cleaning" + "</b>" +
      "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:32% ; right:5.5%'>" + "Departing" + "</b>";
    console.log(q);
    var labels = q.horizontal_axis_2.split("/");

    function ReturnAnimalRight(animal) {
      if (animal == "Zebras") {
        return "81.5%"
      }
      if (animal == "Lions") {
        return "82.5%"
      }
      if (animal == "Elephants") {
        return "79%"
      }
      if (animal == "Girraffes") {
        return "79.5%";
      }
    }

    if (Math.random() > 0.5) {

      html += "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:46% ; right:" + ReturnAnimalRight(labels[0]) + "'>" + labels[0] + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:60% ; right:" + ReturnAnimalRight(labels[1]) + "'>" + labels[1] + "</b>";
      //then have the tally amounts
      var rightPos = 64.5;
      var bigPosModifier = -18.5;

      for (let i = 0; i < orderNumbers.length - 1; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(orderNumbers[i + 1]));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:46%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }

      rightPos = 64.5;
      for (let i = 4; i < 8; i++) {
        console.log(orderNumbers[i]);
        var amount = answers[i];
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:60.5%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    } else {
      html += "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:46% ; right:" + ReturnAnimalRight(labels[1]) + "'>" + labels[1] + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:60% ; right:" + ReturnAnimalRight(labels[0]) + "'>" + labels[0] + "</b>";
      //then have the tally amounts
      var rightPos = 64.5;
      var bigPosModifier = -18.5;

      for (let i = 4; i < 8; i++) {
        console.log(orderNumbers[i]);
        var amount = answers[i];
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:46%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }

      rightPos = 64.5;

      for (let i = 0; i < orderNumbers.length - 1; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(orderNumbers[i + 1]));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:60.5%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }
  }

  if (q.topic_key == "Stat14") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var orderNumbers2 = q.type_of_chart_2.split("/");
    var answers = [];
    console.log(q);
    for (let i = 0; i < 8; i++) {
      answers.push(GenerateRandom(1, 10));
    }
    console.log(answers);

    var answerPlusID = [];
    for (let i = 0; i < 8; i++) {
      answerPlusID.push({
        number: answers[i],
        id: (5 + i)
      })
    }
    console.log(answerPlusID);
    var answerWanted = q.answer_1.split("|");
    answerWanted = answerWanted[1].split(".");
    console.log(answerWanted);

    var sum = 0;
    for (let i = 0; i < answerPlusID.length; i++) {
      //only add the appropriate ones
      if (answerPlusID[i].id == answerWanted[0] || answerPlusID[i].id == answerWanted[1])
        sum += (answerPlusID[i].number)
    }
    console.log("The sum equals " + sum);
    //this works
    correctAnswer = sum;


    var answersUsed = [];
    answersUsed.push(correctAnswer);

    //randomise incorrect answers
    for (let i = 1; i < 4; i++) {
      var ans = GenerateUniqueRandom(1, 20, answersUsed)
      answersUsed.push(ans);
      questionAnswers.push({
        correct: false,
        value: ans,
        answerImage: ""
      });
    }


    //return matching value
    //use id instead???
    function ReturnMatchingValue(id) {
      console.log(id);
      for (let i = 0; i < answerPlusID.length; i++) {
        if (answerPlusID[i].id == id) {
          console.log(id + " matches with " + answerPlusID[i].id + " with a number of " + answerPlusID[i].number)
          return answerPlusID[i].number;
        }
      }
    }

    function ReturnTally(input) {
      if (input == 1)
        return Tally1;
      if (input == 2)
        return Tally2;
      if (input == 3)
        return Tally3;
      if (input == 4)
        return Tally4;
      if (input == 5)
        return Tally5;
    }
    //THIS IS FOR BAR GRAPH
    if (orderNumbers[0] == "Bar") {
      html = '<img src="' + Bar + '"' + "style='position:relative ; right:55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:137%'>" + "Zoo" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:134%'>" + "Zebras" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:134%'>" + "Lions" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:134%'>" + "Elephants" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:134%'>" + "Giraffes" + "</b>";
      var rightPos = 76 + 55;
      var rightmodifier = -7;
      for (let i = 0; i < 11; i++) {
        html +=
          "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
        rightPos += rightmodifier;
      }
      //then have the 3 bars
      var toppos = 70;
      var topModifier = -21;
      var scaleModifier = 0.85;//0.85 per every 1
      for (let i = 5; i < 9; i++) {
        html +=
          //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
          '<img src="' + BarBar + '"' + "style='position:absolute ; right:124%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(i) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
        toppos += topModifier;
      }
    }
    //THIS IS FOR TALLY
    else if (orderNumbers[0] == "Tally") {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:100%'>" + "Zoo" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:131.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:110.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:83.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:63%'>" + "Giraffes" + "</b>";
      //then have the tally amounts
      var rightPos = 57 + 55;
      var bigPosModifier = -22;
      for (let i = 5; i < 9; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        if (amount < 6) {
          html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        } else {
          html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
          html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        }
        rightPos += bigPosModifier;
      }

    }
    //THIS IS FOR TABLE
    else {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:100%'>" + "Zoo" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:131.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:110.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:83.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:63%'>" + "Giraffes" + "</b>";

      //then have the table amounts
      var rightPos = 82 + 55;
      var bigPosModifier = -22.2;
      for (let i = 5; i < 9; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }

    //then make graph on the right using the other values

    //THIS IS FOR BAR GRAPH
    if (orderNumbers2[0] == "Bar") {
      html += '<img src="' + Bar + '"' + "style='position:absolute ; right:-55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:27%'>" + "Safari" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:27%'>" + "Zebras" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:27%'>" + "Lions" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:24%'>" + "Elephants" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:27%'>" + "Giraffes" + "</b>";
      var rightPos = 76 - 55;
      var rightmodifier = -7;
      for (let i = 0; i < 11; i++) {
        html +=
          "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
        rightPos += rightmodifier;
      }
      //then have the 3 bars
      var toppos = 70;
      var topModifier = -21;
      var scaleModifier = 0.85;//0.85 per every 1
      for (let i = 9; i < 13; i++) {
        html +=
          //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
          '<img src="' + BarBar + '"' + "style='position:absolute ; right:14%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(i) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
        toppos += topModifier;
      }
    }
    //THIS IS FOR TALLY
    else if (orderNumbers2[0] == "Tally") {
      html += '<img src="' + Tally + '"' + "style='position:absolute ; right:-55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:-13%'>" + "Safari" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:21.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:0.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-27.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-47%'>" + "Giraffes" + "</b>";
      //then have the tally amounts
      var rightPos = 57 - 55;
      var bigPosModifier = -22;
      for (let i = 9; i < 13; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        if (amount < 6) {
          html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        } else {
          html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
          html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        }
        rightPos += bigPosModifier;
      }

    }
    //THIS IS FOR TABLE
    else {
      html += '<img src="' + Tally + '"' + "style='position:absolute ; right:-55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:-13%'>" + "Safari" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:21.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:0.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-27.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-47%'>" + "Giraffes" + "</b>";

      //then have the table amounts
      var rightPos = 82 - 55;
      var bigPosModifier = -22.2;
      for (let i = 9; i < 13; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }
  }

  //SUBTRACTING MULTIPLE CHARTS
  if (q.topic_key == "Stat15") {
    //this is the order to which is correct
    var orderNumbers = q.type_of_chart_1.split("/");
    var orderNumbers2 = q.type_of_chart_2.split("/");
    var numberRanges = [];
    numberRanges.push(q.answer_5.split("|")[1].split("."))
    numberRanges.push(q.answer_6.split("|")[1].split("."))
    numberRanges.push(q.answer_7.split("|")[1].split("."))
    numberRanges.push(q.answer_8.split("|")[1].split("."))
    numberRanges.push(q.answer_9.split("|")[1].split("."))
    numberRanges.push(q.answer_10.split("|")[1].split("."))
    numberRanges.push(q.answer_11.split("|")[1].split("."))
    numberRanges.push(q.answer_12.split("|")[1].split("."))
    console.log(numberRanges);

    var answers = [];
    console.log(q);
    for (let i = 0; i < 8; i++) {
      answers.push(GenerateRandom(parseInt(numberRanges[i][0]), parseInt(numberRanges[i][1])));
    }
    console.log(answers);

    var answerPlusID = [];
    for (let i = 0; i < 8; i++) {
      answerPlusID.push({
        number: answers[i],
        id: (5 + i)
      })
    }
    console.log(answerPlusID);
    var answerWanted = q.answer_1.split("|");
    answerWanted = answerWanted[1].split(".");
    console.log(answerWanted);

    var min = 0;
    var largest = 0;
    var smallest = 0;
    for (let i = 0; i < answerPlusID.length; i++) {
      //only add the appropriate ones
      if (answerPlusID[i].id == answerWanted[0]) {
        largest = (answerPlusID[i].number)
      } else if (answerPlusID[i].id == answerWanted[1]) {
        smallest = (answerPlusID[i].number)
      }
    }
    min = largest - smallest;
    console.log("The difference equals " + min);
    //this works
    correctAnswer = min;


    var answersUsed = [];
    answersUsed.push(correctAnswer);

    //randomise incorrect answers
    for (let i = 1; i < 4; i++) {
      var ans = GenerateUniqueRandom(1, 5, answersUsed)
      answersUsed.push(ans);
      questionAnswers.push({
        correct: false,
        value: ans,
        answerImage: ""
      });
    }


    //return matching value
    //use id instead???
    function ReturnMatchingValue(id) {
      //console.log(id);
      for (let i = 0; i < answerPlusID.length; i++) {
        if (answerPlusID[i].id == id) {
          //console.log(id + " matches with " + answerPlusID[i].id + " with a number of " + answerPlusID[i].number)
          return answerPlusID[i].number;
        }
      }
    }

    function ReturnTally(input) {
      if (input == 1)
        return Tally1;
      if (input == 2)
        return Tally2;
      if (input == 3)
        return Tally3;
      if (input == 4)
        return Tally4;
      if (input == 5)
        return Tally5;
    }
    //THIS IS FOR BAR GRAPH
    if (orderNumbers[0] == "Bar") {
      html = '<img src="' + Bar + '"' + "style='position:relative ; right:55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:137%'>" + "Zoo" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:134%'>" + "Zebras" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:134%'>" + "Lions" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:134%'>" + "Elephants" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:134%'>" + "Giraffes" + "</b>";
      var rightPos = 76 + 55;
      var rightmodifier = -7;
      for (let i = 0; i < 11; i++) {
        html +=
          "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
        rightPos += rightmodifier;
      }
      //then have the 3 bars
      var toppos = 70;
      var topModifier = -21;
      var scaleModifier = 0.85;//0.85 per every 1
      for (let i = 5; i < 9; i++) {
        html +=
          //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
          '<img src="' + BarBar + '"' + "style='position:absolute ; right:124%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(i) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
        toppos += topModifier;
      }
    }
    //THIS IS FOR TALLY
    else if (orderNumbers[0] == "Tally") {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:100%'>" + "Zoo" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:131.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:110.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:83.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:63%'>" + "Giraffes" + "</b>";
      //then have the tally amounts
      var rightPos = 57 + 55;
      var bigPosModifier = -22;
      for (let i = 5; i < 9; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        if (amount < 6) {
          html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        } else {
          html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
          html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        }
        rightPos += bigPosModifier;
      }
    }

    //THIS IS FOR TABLE
    else {
      html = '<img src="' + Tally + '"' + "style='position:relative ; right:55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:100%'>" + "Zoo" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:131.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:110.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:83.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:63%'>" + "Giraffes" + "</b>";

      //then have the table amounts
      var rightPos = 82 + 55;
      var bigPosModifier = -22.2;
      for (let i = 5; i < 9; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }

    //then make graph on the right using the other values

    //THIS IS FOR BAR GRAPH
    if (orderNumbers2[0] == "Bar") {
      html += '<img src="' + Bar + '"' + "style='position:absolute ; right:-55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:87% ; right:27%'>" + "Safari" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:72% ; right:27%'>" + "Zebras" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:51% ; right:27%'>" + "Lions" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:30% ; right:24%'>" + "Elephants" + "</b>" +
        "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:9% ; right:27%'>" + "Giraffes" + "</b>";
      var rightPos = 76 - 55;
      var rightmodifier = -7;
      for (let i = 0; i < 11; i++) {
        html +=
          "<b style='font-size:20px ; color:#815B37FF; position:absolute ; top:85% ; right:" + rightPos + "%'>" + i + "</b>";
        rightPos += rightmodifier;
      }
      //then have the 3 bars
      var toppos = 70;
      var topModifier = -21;
      var scaleModifier = 0.85;//0.85 per every 1
      for (let i = 9; i < 13; i++) {
        html +=
          //'<img src="' + BarBar + '"' + "style='position:absolute ; top:"+toppos+"%; right:69% ; zIndex:-1'" + '></img>'
          '<img src="' + BarBar + '"' + "style='position:absolute ; right:14%; top:" + toppos + "%; transform: scale(" + 0.85 * ReturnMatchingValue(i) + "," + "1".toString() + ") ; transform-origin: 0% 100%;  zIndex:-1'" + '></img>'
        toppos += topModifier;
      }
    }
    //THIS IS FOR TALLY
    else if (orderNumbers2[0] == "Tally") {
      html += '<img src="' + Tally + '"' + "style='position:absolute ; right:-55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:-13%'>" + "Safari" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:21.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:0.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-27.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-47%'>" + "Giraffes" + "</b>";
      //then have the tally amounts
      var rightPos = 57 - 55;
      var bigPosModifier = -22;
      for (let i = 9; i < 13; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        if (amount < 6) {
          html += '<img src="' + ReturnTally(amount) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        } else {
          html += '<img src="' + ReturnTally(5) + '"' + "style='position:absolute ; top:6%; right:" + rightPos + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
          html += '<img src="' + ReturnTally(amount - 5) + '"' + "style='position:absolute ; top:6%; right:" + (rightPos - 10) + "%; transform: scale(0.75,0.75);  zIndex:-1'" + '></img>';
        }
        rightPos += bigPosModifier;
      }

    }
    //THIS IS FOR TABLE
    else {
      html += '<img src="' + Tally + '"' + "style='position:absolute ; right:-55% ; zIndex:-1'" + '></img>' +
        "<b style='font-size:30px ; color:#815B37FF; position:absolute ; top:5% ; right:-13%'>" + "Safari" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:21.5%'>" + "Zebras" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:0.5%'>" + "Lions" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-27.5%'>" + "Elephants" + "</b>" +
        "<b style='font-size:22px ; color:#815B37FF; position:absolute ; top:38% ; right:-47%'>" + "Giraffes" + "</b>";

      //then have the table amounts
      var rightPos = 82 - 55;
      var bigPosModifier = -22.2;
      for (let i = 9; i < 13; i++) {
        console.log(orderNumbers[i]);
        var amount = (ReturnMatchingValue(i));
        html += "<b style='font-size:22px ; color:#815B37FF; position:absolute ; right:" + rightPos + "% ; top:52%'>" + amount + "</b>";

        rightPos += bigPosModifier;
      }
    }
  }

  if (q.topic_key == "Stat12") {
    //this is the order to which is correct
    var graphId = GenerateRandom(1, 4);
    var numbers = [];

    if (graphId == 1) {
      numbers.push(3);
      numbers.push(9);
      numbers.push(6);
      numbers.push(2);
    }
    else if (graphId == 2) {
      numbers.push(1);
      numbers.push(9);
      numbers.push(6);
      numbers.push(10);
    }
    else if (graphId == 3) {
      numbers.push(2);
      numbers.push(5);
      numbers.push(9);
      numbers.push(7);
    }
    else if (graphId == 4) {
      numbers.push(10);
      numbers.push(7);
      numbers.push(3);
      numbers.push(8);
    }
    else if (graphId == 5) {
      numbers.push(8);
      numbers.push(9);
      numbers.push(1);
      numbers.push(3);
    }
    console.log(q);
    console.log(temps);

    var orderNumbers = q.type_of_chart_1.split("/");
    var answers = [];

    var usedNumbers = [];
    //get correct number
    var correctId;
    if (q.question.includes("lions")) {
      correctId = 1;
    }
    if (q.question.includes("zebras")) {
      correctId = 0;
    }
    if (q.question.includes("elephants")) {
      correctId = 2;
    }
    if (q.question.includes("giraffes")) {
      correctId = 3;
    }
    correctAnswer = numbers[correctId]
    //use the rest for incorrect

    answers.push(correctAnswer);
    for (let i = 0; i < 4; i++) {
      if (correctId != i)
        answers.push(numbers[i]);
    }

    questionAnswers.push({
      correct: false,
      value: answers[1],
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[2],
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: answers[3],
      answerImage: ""
    });
    //return matching value
    function ReturnMatchingValue(input) {
      for (let i = 0; i < answers.length; i++) {
        if (i + 1 == input) {
          return answers[i];
        }
      }
    }

    function ReturnPieChart() {
      if (graphId == 1)
        return Pie1;
      if (graphId == 2)
        return Pie2;
      if (graphId == 3)
        return Pie3;
      if (graphId == 4)
        return Pie4;
      if (graphId == 5)
        return Pie5;
    }

    html = '<img src="' + ReturnPieChart() + '"' + "style='position:relative ; transform: scale(0.8,0.8) ; right:0% ; zIndex:-1'" + '></img>';
  }

  //A GREATER THAN B
  else if (q.topic_key == "Stat13") {

    function ReturnMean(input) {
      var total = 0;
      for (let i = 0; i < input.length; i++) {
        total += input[i];
      }
      return total / input.length;
    }

    function ScrambleArray(mean) {
      console.log(mean);
      var array = [];
      for (let i = 0; i < 4; i++) {
        array.push(mean);
      }
      //if decimal then add 1 to 2 random ones
      if (Number.isInteger(mean) == false) {
        for (let i = 0; i < 4; i++) {
          array[i] -= 0.5;
        }
        for (let i = 0; i < 2; i++) {
          array[GenerateRandom(0, 3)] += 1;
        }
      }
      console.log(array);
      console.log(mean * 4 / 4)
      //then scramble by add one minus one from other
      for (let i = 0; i < 7; i++) {
        //get random id
        let idUsed = [];
        let firstId = GenerateRandom(0, 3);
        idUsed.push(firstId);
        let secondId = GenerateUniqueRandom(0, 3, idUsed);
        if (array[secondId] > 1.5) {
          array[firstId] += 1;
          array[secondId] -= 1;
        }
      }
      console.log("scrambled");
      console.log(array);
      console.log(ReturnMean(array));
      return array;
    }

    correctAnswer = GenerateRandom(3, 6);
    if (Math.random() > 0.5)
      correctAnswer += 0.5;

    var numberLine = ScrambleArray(correctAnswer);

    //generate wrong answers
    var answersUsed = [];
    for (let i = 0; i < 3; i++) {
      var rand = GenerateUniqueRandom(1, 10, answersUsed);
      answersUsed.push(rand);
      if (Math.random() > 0.5)
        rand += 0.5;

      questionAnswers.push({
        correct: false,
        value: rand,
        answerImage: ""
      });
    }

    //show image

    html = '<img src="' + Sequence + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<b style='font-size:100px ; color:white; position:absolute ; top:20% ; right:120%'>" + numberLine[0] + "</b>" +
      "<b style='font-size:100px ; color:white; position:absolute ; top:20% ; right:70%'>" + numberLine[1] + "</b>" +
      "<b style='font-size:100px ; color:white; position:absolute ; top:20% ; right:20%'>" + numberLine[2] + "</b>" +
      "<b style='font-size:100px ; color:white; position:absolute ; top:20% ; right:-30%'>" + numberLine[3] + "</b>";
  }


  questionAnswers.push({
    correct: true,
    value: correctAnswer,
    answerImage: correctAnswerImage
  });

  shuffleArray(questionAnswers);

  let question = {
    question: questionString,
    answers: questionAnswers,
    image: imageString,
    topic_id: q.topic_id,
    questionHTML: html,
    subject: "statistics"
  }
  return question;
}

//#region Multiplication

function ReturnMultiplication(q) {
  if (q == undefined || q.example_question == undefined) {
    console.log(q);
    return null;
  }
  console.log(q.example_question);

  let i = Math.floor(Math.random() * 12 + 1);
  let generatedCalculation = [];
  let calc = q.example_question.split(" ");
  if (calc.length === 3) {
    const number2 = parseInt(calc[2]);
    const number1 = calc[1] === "÷" ? i * number2 : i;
    generatedCalculation[0] = number1;
    generatedCalculation[1] = calc[1];
    generatedCalculation[2] = number2;
  } else if (calc.length === 5) {
    // if got length of 5 then we expect [number1 , operator, number2, operator, number3] (eg. a x b x c) and need to generate a random number for each part of the calulation
    const number1 = Math.floor(Math.random() * 9 + 1);
    const number2 = Math.floor(Math.random() * 9 + 1);
    const number3 = Math.floor(Math.random() * 9 + 1);
    const operator = "x";
    generatedCalculation[0] = number1;
    generatedCalculation[1] = operator;
    generatedCalculation[2] = number2;
    generatedCalculation[3] = operator;
    generatedCalculation[4] = number3;
  }

  if (q.topic_key == "multiple10") {//times by multiple of 10
    let num1 = GenerateRandom(1, 99);
    var num2array = [10, 100, 1000];
    var num2 = num2array[GenerateRandom(0, num2array.length)];
    const operator = "x";
    //
    generatedCalculation[0] = num1;
    generatedCalculation[1] = operator;
    generatedCalculation[2] = num2;
}
if (q.topic_key == "multiple10+1") {//times by almost a multiple of 10
    let num1 = GenerateRandom(1, 99);
    var num2array = [9, 99, 999, 11, 101, 1001];
    var num2 = num2array[GenerateRandom(0, num2array.length)];
    const operator = "x";
    //
    generatedCalculation[0] = num1;
    generatedCalculation[1] = operator;
    generatedCalculation[2] = num2;
}
if (q.topic_key == "dec") {//times by decimal
    //generate answer first and then work backwards
    var num2array = [10, 100, 1000];
    var num2 = num2array[GenerateRandom(0, num2array.length)];
    let ans = 0;
    if (num2 == 10) {
        ans = GenerateRandom(1, 10)
    }
    if (num2 == 100) {
        ans = GenerateRandom(11, 100)
    }
    if (num2 == 1000) {
        ans = GenerateRandom(101, 1000)
    }
    let num1 = ans / num2;
    const operator = "x";
    //
    generatedCalculation[0] = num1;
    generatedCalculation[1] = operator;
    generatedCalculation[2] = num2;
    ans = Math.round(ans);
}
if (q.topic_key == "cubes") {//cube a number
    var override = "cubes";
    var num1 = GenerateRandom(2, 10);
    const operator = "^";
    //
    generatedCalculation[0] = num1;
    generatedCalculation[1] = "³";
    var ans = num1 * num1 * num1;
}
if (q.topic_key == "multorder"){//multiplication order
    var override = "multorder";
    var num1 = GenerateRandom(2,10);
    var num2 = GenerateRandom(2,10);
    var num3 = GenerateRandom(1,num2);
    //
    generatedCalculation[0] = num1;
    generatedCalculation[1] = "*";
    generatedCalculation[2] = "(";
    generatedCalculation[3] = num2;
    generatedCalculation[4] = "-";
    generatedCalculation[5] = num3;
    generatedCalculation[6] = ")";
    var ans = num1*(num2-num3);
}
if (q.topic_key == "divorder"){//multiplication order
    var override = "divorder";
    var ans = GenerateRandom(1,10);
    var num1 = GenerateRandom(2,10);
    var num2 = GenerateRandom(1,num1);
    var num3 = ans * (num1 - num2);
    //
    generatedCalculation[0] = num3;
    generatedCalculation[1] = "÷";
    generatedCalculation[2] = "(";
    generatedCalculation[3] = num1;
    generatedCalculation[4] = "-";
    generatedCalculation[5] = num2;
    generatedCalculation[6] = ")";
}
if (q.topic_key == "squares"){//square a number
    var override = "squares";
    var num1 = GenerateRandom(2,10);
    const operator = "^";
    //
    generatedCalculation[0] = num1;
    generatedCalculation[1] = "²";
    var ans = num1*num1;
}
if (q.topic_key == "squares2"){//cube a number
    var override = "squares2";
    var num1 = GenerateRandom(1,10);
    var num2 = GenerateRandom(1,9);
    var ans = (num1*num1) + num2;
    //
    generatedCalculation[0] = num1;
    generatedCalculation[1] = "²";
    generatedCalculation[2] = "+";
    generatedCalculation[3] = num2;
    
}
if (q.topic_key == "div"){//advanced div
    var num1 = GenerateRandom(1,10);
    var num2 = GenerateRandom(1,10)*num1*10;
    var ans = num2/num1;
    //
    generatedCalculation[0] = num2;
    generatedCalculation[1] = "÷";
    generatedCalculation[2] = num1;
}

if(q.topic_key == "count2")
{
    var override = "counting";
    var extraNumbers = "";
    var num1array = [2,4,6,8,10,12,14,16];
    var num1 = num1array[GenerateRandom(0, num1array.length)];

    for (var y = 0; y < 3; y++)
    {
        extraNumbers += num1 + ", ";
        num1 += 2;
    }

    var ans = num1;

    generatedCalculation[0] = "Counting in 2s, what is next in the sequence? ";
    generatedCalculation[1] = extraNumbers;
    generatedCalculation[2] = "?";
}
if(q.topic_key == "count3")
{
    var override = "counting";
    var extraNumbers = "";
    var num1array = [3,6,9,12,15,18,21,24];
    var num1 = num1array[GenerateRandom(0, num1array.length)];

    for (var y = 0; y < 3; y++)
    {
        extraNumbers += num1 + ", ";
        num1 += 3;
    }

    var ans = num1;

    generatedCalculation[0] = "Counting in 3s, what is next in the sequence? ";
    generatedCalculation[1] = extraNumbers;
    generatedCalculation[2] = "?";
}
if(q.topic_key == "count4")
{
    var override = "counting";
    var extraNumbers = "";
    var num1array = [4,8,12,16,20,24,28,32];
    var num1 = num1array[GenerateRandom(0, num1array.length)];

    for (var y = 0; y < 3; y++)
    {
        extraNumbers += num1 + ", ";
        num1 += 4;
    }

    var ans = num1;

    generatedCalculation[0] = "Counting in 4s, what is next in the sequence? ";
    generatedCalculation[1] = extraNumbers;
    generatedCalculation[2] = "?";
}
if(q.topic_key == "count5")
{
    var override = "counting";
    var extraNumbers = "";
    var num1array = [5,10,15,20,25,30,35,40];
    var num1 = num1array[GenerateRandom(0, num1array.length)];

    for (var y = 0; y < 3; y++)
    {
        extraNumbers += num1 + ", ";
        num1 += 5;
    }

    var ans = num1;

    generatedCalculation[0] = "Counting in 5s, what is next in the sequence? ";
    generatedCalculation[1] = extraNumbers;
    generatedCalculation[2] = "?";
}
if(q.topic_key == "count6")
{
    var override = "counting";
    var extraNumbers = "";
    var num1array = [6,12,18,24,30,36,42,48];
    var num1 = num1array[GenerateRandom(0, num1array.length)];

    for (var y = 0; y < 3; y++)
    {
        extraNumbers += num1 + ", ";
        num1 += 6;
    }

    var ans = num1;

    generatedCalculation[0] = "Counting in 6s, what is next in the sequence? ";
    generatedCalculation[1] = extraNumbers;
    generatedCalculation[2] = "?";
}
if(q.topic_key == "count7")
{
    var override = "counting";
    var extraNumbers = "";
    var num1array = [7,14,21,28,35,42,49,56];
    var num1 = num1array[GenerateRandom(0, num1array.length)];

    for (var y = 0; y < 3; y++)
    {
        extraNumbers += num1 + ", ";
        num1 += 7;
    }

    var ans = num1;

    generatedCalculation[0] = "Counting in 7s, what is next in the sequence? ";
    generatedCalculation[1] = extraNumbers;
    generatedCalculation[2] = "?";
}
if(q.topic_key == "count8")
{
    var override = "counting";
    var extraNumbers = "";
    var num1array = [8,16,24,32,40,48,56,64];
    var num1 = num1array[GenerateRandom(0, num1array.length)];

    for (var y = 0; y < 3; y++)
    {
        extraNumbers += num1 + ", ";
        num1 += 8;
    }

    var ans = num1;

    generatedCalculation[0] = "Counting in 8s, what is next in the sequence? ";
    generatedCalculation[1] = extraNumbers;
    generatedCalculation[2] = "?";
}
if(q.topic_key == "count9")
{
    var override = "counting";
    var extraNumbers = "";
    var num1array = [9,18,27,34,45,54,63,72];
    var num1 = num1array[GenerateRandom(0, num1array.length)];

    for (var y = 0; y < 3; y++)
    {
        extraNumbers += num1 + ", ";
        num1 += 9;
    }

    var ans = num1;

    generatedCalculation[0] = "Counting in 9s, what is next in the sequence? ";
    generatedCalculation[1] = extraNumbers;
    generatedCalculation[2] = "?";
}
let questionText = generatedCalculation.join(" ");
let questionAnswers = [];
if (override == undefined) {
    let correctAnswer = MultGetAnswer(generatedCalculation);
    let wrongAnswers = [];
    questionAnswers.push({
        correct: true,
        value: MultGetAnswer(generatedCalculation)
    });
    for (var n = 1; n < 4; n++) {
        var newIncorrectAnswer = MultGetWrongAnswer(
            correctAnswer,
            wrongAnswers
        );
        wrongAnswers.push(newIncorrectAnswer);
        questionAnswers.push({
            correct: false,
            value: newIncorrectAnswer
        });
    }
}else{
    let correctAnswer = ans;
    let wrongAnswers = [];
    let usedAnswers = [];
    questionAnswers.push({
        correct: true,
        value: ans
    })
    console.log(generatedCalculation);
    console.log(q.topic_key);
    usedAnswers.push(ans);
    for (var n = 1; n < 4; n++) {
        if (ans == 1){
            var newIncorrectAnswer = 1 + GenerateRandom(1,5);
        }else{
            var newIncorrectAnswer = RandomPercentageDifference(ans,25,150,usedAnswers) //plus or minus up to 15%
        }
        wrongAnswers.push(newIncorrectAnswer);
        usedAnswers.push(newIncorrectAnswer);
        questionAnswers.push({
            correct: false,
            value: newIncorrectAnswer
        });
    }
}

  shuffleArray(questionAnswers);

  let questionObj = {
    question: questionText,
    answers: questionAnswers,
    subject: "multiplication",

  };
  return questionObj;
}

function MultGetAnswer(calculation) {
  const calculationParts = calculation;

  if (calculationParts.length === 3) {
      const [number1, operator, number2] = calculationParts;

      switch (operator) {
          case "÷":
              return number1 / number2;
          case "x":
              return number1 * number2;
          default:
              break;
      }
  } else if (calculationParts.length === 5) {
      let number1 = calculationParts[0];
      let number2 = calculationParts[2];
      let number3 = calculationParts[4];
      return number1 * number2 * number3;
  } else {
      return 0;
  }
}

function MultGetWrongAnswer(correctAnswer, existingWrongAnswers) {
  var addOrSubtract = [0, 1];
  var output = 0;
  var getAnswer = true;

  do {
      var operatorSelection = Math.floor(Math.random() * addOrSubtract.length);
      var differenceSelection = Math.floor(Math.random() * 10);
      if (operatorSelection === 0) {
          output = correctAnswer - differenceSelection;
      } else {
          output = correctAnswer + differenceSelection;
      }

      if (
          existingWrongAnswers.includes(output) === false &&
          output !== correctAnswer &&
          output > 0
      ) {
          getAnswer = false;
      }
  } while (getAnswer === true);

  return output;
}

//#endregion

//#region num place

function uniqueItem(value, list) {
  for (var i = 0; i < list.length; i++)
    if (value === list[i].value)
      return false;
  return true;
}

function uniqueFormula(input, insert, list) {
  var ans = parseFormula(input, insert);
  if (uniqueItem(ans, list))
    return ans;

  for (var i = 0; i < 5; i++) {
    ans = parseFormula(input, insert);
    if (uniqueItem(ans, list))
      return ans;
  }

  var max = parseFloat(list[0].value);
  if (max < 10)
    max = 10;
  for (var i = 0; i < 5; i++) {
    ans = parseFormula("Rand|" + parseFloat(max) / 2 + "|" + max + "|1", input, insert);
    if (uniqueItem(ans, list))
      return ans;
  }
  return ans;
}

function parseFormula(input, insert) {
  var newInput = input.replace("$", insert[0]).replace("^", insert[1]);
  if (input.includes("|")) {
    let parts = newInput.split('|');
    if (parts[0] === "Add")
      return parseInt(parts[1]) + parseInt(parts[2]);

    else if (parts[0] === "Sub")
      return parseInt(parts[1]) - parseInt(parts[2]);

    else if (parts[0] === "Seque4")
      return parseInt(parts[1]) + "; " + (parseInt(parts[1]) + parseInt(parts[2])) + "; " + (parseInt(parts[1]) + parseInt(parts[2] * 2)) + "; " + (parseInt(parts[1]) + parseInt(parts[2] * 3));

    else if (parts[0] === "Rand")
      return Math.round(parseInt(parts[1]) + Math.random() * (parseInt(parts[2]) - parseInt(parts[1]))) * parseInt(parts[3]);

    else if (parts[0] === "Rand2") {
      var answer = Math.round(parseInt(parts[1]) + Math.random() * (parseInt(parts[2]) - parseInt(parts[1])) / 2) * parseInt(parts[3]);
      var answer2 = Math.round(answer + Math.random() * (parseInt(parts[2]) - parseInt(parts[1])) / 2) * parseInt(parts[3]);
      return (answer + "|" + answer2);
    }
    else if (parts[0] === "Char")
      return parts[1].toString()[parts[1].length - parseInt(parts[2])];

    else if (parts[0] === "Round") {
      var round = parseInt(parts[1]) / parseInt(parts[2]);
      var ans = Math.round(round) * parseInt(parts[2]);
      return ans;
    }


    else if (parts[0] === "RoundUp") {
      var round = parseInt(parts[1]) / parseInt(parts[2]);
      var ans = 0;
      if (Math.ceil(round) * parseInt(parts[2]) == Math.round(round) * parseInt(parts[2])) {
        ans = Math.ceil(round) * parseInt(parts[2]) + parseInt(parts[2]);
      } else {
        ans = Math.ceil(round) * parseInt(parts[2]);
      }
      return ans;
    }


    else if (parts[0] === "RoundDown") {
      var round = parseInt(parts[1]) / parseInt(parts[2]);
      var ans = 0;
      if (Math.floor(round) * parseInt(parts[2]) == Math.round(round) * parseInt(parts[2])) {
        ans = Math.floor(round) * parseInt(parts[2]) - parseInt(parts[2]);
      } else {
        ans = Math.floor(round) * parseInt(parts[2]);
      }
      return ans;
    }
  }
  return newInput;
}

function ReturnNumberPlace(q) {
  let generatedCalculation = [];
  console.log(q);

  let qKeys = ["Num1Q1", "Num1Q2", "Num3Q1", "Num4Q1", "Num5Q1", "Num6Q1", "Num7Q1", "Num7Q111", "Num8Q1", "Num9Q1", "Num9Q2", "Num11Q1", "Num12Q1", "Num13Q1", "Num14Q1", "Num15Q1", "Num15Q38", "Num15Q112", "Num15Q185", "Num16Q1", "Num16Q123", "Num16Q184", "Num17Q1", "Num17Q2", "Num19Q1", "Num20Q1", "Num21Q1", "Num22Q1", "Num23Q1", "Num24Q1", "Num24Q111", "Num25Q1", "Num25Q111", "Num25Q184", "Num25Q292", "Num26Q1", "Num26Q13", "Num26Q19", "Num26Q24", "Num26Q34", "Num26Q44", "Num26Q53", "Num26Q63", "Num26Q73", "Num26Q83", "Num27Q1", "Num27Q2", "Num28Q1", "Num28Q147", "Num28Q256", "Num29Q1", "Num29Q2", "Num29Q147", "Num29Q148", "Num29Q149", "Num29Q150", "Num29Q151", "Num29Q152", "Num29Q153", "Num29Q154", "Num29Q155", "Num29Q156", "Num29Q239", "Num29Q240", "Num29Q241", "Num29Q242", "Num29Q243", "Num29Q244", "Num29Q245", "Num29Q246", "Num29Q247", "Num29Q248", "Num30Q1", "Num30Q111", "Num30Q184", "Num30Q292", "Num30Q437", "Num30Q546", "Num31Q1", "Num31Q110", "Num32Q1", "Num32Q147", "Num32Q256", "Num32Q363", "Num32Q508", "Num33Q1", "Num33Q2", "Num34Q1", "Num34Q111", "Num34Q184", "Num34Q292", "Num34Q437", "Num34Q546", "Num34Q692", "Num35Q1", "Num35Q147", "Num35Q256", "Num35Q363", "Num35Q508"];
  let generator = ["Rand|11|188|1", "Rand|11|188|1", "Rand|0|30|1", "Rand|0|90|1", "Rand|0|100|1", "Rand|1|15|10", "Rand|10|99|1", "Rand|10|99|1", "Rand|2|20|1", "Rand2|1|100|1", "Rand2|1|100|1", "Rand|0|20|4", "Rand|0|20|8", "Rand|0|12|50", "Rand|0|12|100", "Rand|200|9900|1", "Rand|200|9900|1", "Rand|200|9900|1", "Rand|200|9900|1", "Rand|100|990|1", "Rand|100|990|1", "Rand|100|990|1", "Rand2|100|990|1", "Rand2|100|990|1", "Rand|25|970|1", "Rand|25|970|1", "Rand|25|970|1", "Rand|25|870|1", "Rand|200|9870|1", "Rand|2000|98870|1", "Rand|2000|98870|1", "Rand|100|970|1", "Rand|100|970|1", "Rand|100|970|1", "Rand|10000|97000|1", "Rand|-15|-1|1", "Rand|-20|-2|1", "Rand|-30|-3|1", "Rand|-40|-4|1", "Rand|-50|-5|1", "Rand|-60|-6|1", "Rand|-70|-7|1", "Rand|-80|-8|1", "Rand|-90|-9|1", "Rand|-100|-10|1", "Rand2|1000|9900|1", "Rand2|1000|9900|1", "Rand|1000|9900|1", "Rand|1000|9900|1", "Rand|1000|9900|1", "Rand2|100000|990000|1", "Rand2|100000|990000|1", "Rand|-15|-1|1", "Rand|-20|-2|1", "Rand|-30|-3|1", "Rand|-40|-4|1", "Rand|-50|-5|1", "Rand|-60|-6|1", "Rand|-70|-7|1", "Rand|-80|-8|1", "Rand|-90|-9|1", "Rand|-100|-10|1", "Rand|-15|15|1", "Rand|-20|20|1", "Rand|-30|30|1", "Rand|-40|40|1", "Rand|-50|50|1", "Rand|-60|60|1", "Rand|-70|70|1", "Rand|-80|80|1", "Rand|-90|90|1", "Rand|-100|100|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|10000|97000|1", "Rand|10000|97000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand|100000|970000|1", "Rand2|1000000|9900000|1", "Rand2|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|1000000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1", "Rand|100000|9900000|1"];
  var randomNumbers = [];

  if (q.topic_key == "num36") {
    var num1 = GenerateRandom(1, 9) * 100;
    var num2 = GenerateRandom(1, 9) * 10;
    var num3 = GenerateRandom(1, 9);
    var questionText = "What is the missing number?";
    questionText += ": " + num1 + "+ _ +" + num3.toString() + " = " + (num1 + num2 + num3);
    correctAnswer = num2;
    var usedAnswers = [];
    var questionAnswers = [];
    usedAnswers.push(correctAnswer);
    for (let i = 0; i < 3; i++) {
      var wrong = GenerateUniqueRandom(10, 90, usedAnswers);
      usedAnswers.push(wrong);
      questionAnswers.push({ correct: false, value: wrong });
    }
    questionAnswers.push({ correct: true, value: correctAnswer });
  } else if (q.topic_key == "num37"){
    var mult10 = [10,100,1000];
    var multby1 = GenerateRandom(0,2);
    var multby2 = GenerateRandom(multby1,2);
    var num1 = GenerateRandom(1,10)*mult10[multby2];
    var num2 = mult10[multby1];
    var correctAnswer = num1/num2;
    var questionText = num1 + " ÷ " + num2 + " =";
    var wrongInt = num1 / mult10[multby2];

    var usedAnswers = [];
    var questionAnswers = [];
    for (let i = 0; i < 3; i++) {
      wrongInt = wrongInt*10;
      usedAnswers.push(wrongInt);
      questionAnswers.push({correct: false, value: wrongInt});
    }
    questionAnswers.push({correct: true, value: correctAnswer})
  }else if (q.topic_key == "num38"){
    var mult10 = [10,100,1000];
    var multby1 = GenerateRandom(0,2);
    var n1 = GenerateRandom(1,99);
    var num1 = n1/100;
    var num2 = mult10[GenerateRandom(0,3)];
    var correctAnswer = num1 / num2;


    var questionText = num1 + " ÷ " + num2 + " =";

    var usedAnswers = [];
    var questionAnswers = [];
    num1 = num1 * num2;
    for (let i = 0; i < 3; i++) {
      num1 = num1/10;
      num1 = parseFloat(num1.toFixed(12));
      usedAnswers.push(num1);
      console.log(num1);
      questionAnswers.push({correct: false, value: num1.toString()});
    }
    correctAnswer = parseFloat(correctAnswer.toFixed(12));
    questionAnswers.push({correct: true, value: correctAnswer.toString()})
  }else {
    if (qKeys.includes(q.question_key))
      randomNumbers = parseFormula(generator[qKeys.indexOf(q.question_key)], [0, 0]).toString().split('|');
    console.log(randomNumbers);

    var questionText = parseFormula(q.line_1, randomNumbers);
    if (q.line_2 !== "" && q.line_2 !== undefined)
      questionText += ": " + parseFormula(q.line_2, randomNumbers);
    var questionAnswers = [];
    var correctAnswer = parseFormula(q.correct_answer, randomNumbers).toString();
    //console.log(questionText + ": " + correctAnswer);
    let wrongAnswers = [];
    questionAnswers.push({
      correct: true,
      value: correctAnswer
    });

    questionAnswers.push({ correct: false, value: uniqueFormula(q.wrong_answer_1, randomNumbers, questionAnswers).toString() });
    questionAnswers.push({ correct: false, value: uniqueFormula(q.wrong_answer_2, randomNumbers, questionAnswers).toString() });
    if (q.wrong_answer_3 !== undefined && q.wrong_answer_3 !== "")
      questionAnswers.push({ correct: false, value: uniqueFormula(q.wrong_answer_3, randomNumbers, questionAnswers).toString() });
  }

  shuffleArray(questionAnswers);

  let questionObj = {
    question: questionText,
    answers: questionAnswers,
    subject: "numplace"
  };

  return questionObj;
}
//#endregion

function RandomChar() {
  var result = '';
  var characters = 'abcdefghijklmnopqrstuvwxyz';
  var charactersLength = characters.length;
  result = characters.charAt(Math.floor(Math.random() * charactersLength));
  return result;
}

function ReturnAlgebra(q) {
  console.log(q.question_key);
  //All the shared variables
  let questionAnswers = [];
  var questionText = "";
  var correctAnswer = "";
  let wrongAnswers = [];
  //First question type
  if (q.question_key === "AlgebraQ1") {
    const theChar = RandomChar();
    const number1 = Math.floor(Math.random() * 6 + 5);
    const number2 = Math.floor(Math.random() * (number1 - 1) + 1);
    const theAnswer = number1 - number2;
    questionText = q.question_line_1;
    questionText = questionText.replace('&', theChar).replace('&', theChar).replace('£', theAnswer).replace('^', number1);
    correctAnswer = number2;
    //Create the 3 wrong answers (From -5 to +5 the answer)
    for (var j = 0; j < 3; j++) {
      var randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      while (wrongAnswers.includes(randAns) || randAns == correctAnswer)
        randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      wrongAnswers.push(randAns);
    }
  }
  //Second Question type
  if (q.question_key === "AlgebraQ2") {
    const theChar = RandomChar();
    const number1 = Math.floor(Math.random() * 4 + 1);
    const number2 = Math.floor(Math.random() * (10 - number1) + (number1 + 1));
    const number3 = number1 + number2;
    questionText = q.question_line_1;
    questionText = questionText.replace('&', theChar).replace('&', theChar).replace('£', number1).replace('^', number2);
    correctAnswer = number3;
    //Create the 3 wrong answers (From -5 to +5 the answer)
    for (var j = 0; j < 3; j++) {
      var randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      while (wrongAnswers.includes(randAns) || randAns == correctAnswer)
        randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      wrongAnswers.push(randAns);
    }
  }
  //Third Question type
  if (q.question_key === "AlgebraQ3") {
    const theChar = RandomChar();
    const number1 = Math.floor(Math.random() * 5 + 1);
    const number2 = Math.floor(Math.random() * 5 + 1);
    const number3 = number1 * number2;
    questionText = q.question_line_1;
    questionText = questionText.replace('&', theChar).replace('&', theChar).replace('£', number1).replace('^', number3);
    correctAnswer = number2;
    //Create the 3 wrong answers (From -5 to +5 the answer)
    for (var j = 0; j < 3; j++) {
      var randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      while (wrongAnswers.includes(randAns) || randAns == correctAnswer)
        randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      wrongAnswers.push(randAns);
    }
  }
  //Forth Question type
  if (q.question_key === "AlgebraQ4") {
    const theChar = RandomChar();
    const number1 = Math.floor(Math.random() * 5 + 1);
    const number2 = Math.floor(Math.random() * 5 + 1);
    const number3 = Math.floor(Math.random() * 5 + 1);
    questionText = q.question_line_1;
    questionText = questionText.replace('&', theChar).replace('n&', number2 + theChar).replace('£', number1).replace('*', number3);
    correctAnswer = (number1 * number2) + number3;
    //Create the 3 wrong answers (From -5 to +5 the answer)
    for (var j = 0; j < 3; j++) {
      var randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      while (wrongAnswers.includes(randAns) || randAns == correctAnswer)
        randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      wrongAnswers.push(randAns);
    }
  }
  //Fifth Question type
  if (q.question_key === "AlgebraQ5") {
    const theChar = RandomChar();
    const number1 = Math.floor(Math.random() * 5 + 1);
    const number2 = Math.floor(Math.random() * 5 + 1);
    const number3 = Math.floor(Math.random() * 5 + 1);
    questionText = q.question_line_1;
    questionText = questionText.replace('&', theChar).replace('n&', number2 + theChar).replace('£', number1).replace('*', number3);
    correctAnswer = (number1 * number2) - number3;
    //Create the 3 wrong answers (From -5 to +5 the answer)
    for (var j = 0; j < 3; j++) {
      var randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      while (wrongAnswers.includes(randAns) || randAns == correctAnswer)
        randAns = correctAnswer + Math.floor(Math.random() * 10 - 5);
      wrongAnswers.push(randAns);
    }
  }
  //Sixth Question type
  if (q.question_key === "AlgebraQ6") {
    const number1 = Math.floor(Math.random() * 5 + 1);
    const number2 = Math.floor(Math.random() * 4 + 2);
    var sequence = ' ';
    for (var j = 0; j < 4; j++) {
      sequence += (number1 + (number2 * j)) + ', ';
    }
    sequence += '%';
    sequence = sequence.replace(', %', '...');
    questionText = q.question_line_1 + sequence;
    correctAnswer = "Add " + number2;
    let randAnswers = [];
    //Create the 3 wrong answers (From -5 to +5 the answer)
    for (var j = 0; j < 3; j++) {
      var randAns = number2 + Math.floor(Math.random() * 10 - 5);
      while (randAnswers.includes(randAns) || randAns == number2)
        randAns = number2 + Math.floor(Math.random() * 10 - 5);
      randAnswers.push(randAns);
      wrongAnswers.push("Add " + randAns);
    }
  }
  //Seventh Question type
  if (q.question_key === "AlgebraQ7") {
    const number1 = Math.floor(Math.random() * 8 + 3);
    const number2 = Math.floor(Math.random() * (number1 - 1) + 1);
    questionText = q.question_line_1;
    questionText = questionText.replace('£', number1)
    correctAnswer = number2 + " and " + (number1 - number2);
    wrongAnswers.push((number2 - 1) + " and " + (number1 - number2));
    wrongAnswers.push(number2 + " and " + (number1 - number2 + 1));
    wrongAnswers.push((number2 + 1) + " and " + (number1 - number2 + 1));
  }
  //Eighth Question type
  if (q.question_key === "AlgebraQ8") {
    const theChar = RandomChar();
    var otherChar = RandomChar();
    while (theChar == otherChar)
      otherChar = RandomChar();
    const number1 = Math.floor(Math.random() * 5 + 1);
    const number2 = Math.floor(Math.random() * 5 + 1);
    const number3 = Math.floor(Math.random() * 4 + 2);
    const number4 = Math.floor(Math.random() * 4 + 2);
    var ansNum = (number1 * number3) + (number2 * number4);
    questionText = q.question_line_1;
    questionText = questionText.replace('£1&1', number1 + theChar).replace('£2&2', number2 + otherChar).replace('^', ansNum);
    correctAnswer = theChar + " = " + number3 + ", " + otherChar + " = " + number4;
    wrongAnswers.push(theChar + " = " + (number3 + 1) + ", " + otherChar + " = " + number4);
    wrongAnswers.push(theChar + " = " + number3 + ", " + otherChar + " = " + (number4 - 1));
    wrongAnswers.push(theChar + " = " + (number3 - 1) + ", " + otherChar + " = " + (number4 + 1));
  }
  //Ninth Question type
  if (q.question_key === "AlgebraQ9") {
    const theChar = RandomChar();
    var otherChar = RandomChar();
    while (theChar == otherChar)
      otherChar = RandomChar();
    const number1 = Math.floor(Math.random() * 4 + 2);
    questionText = q.question_line_1;
    questionText = questionText.replace('£L1', number1 + theChar).replace('L2', otherChar);
    correctAnswer = number1 + otherChar + theChar;
    wrongAnswers.push((number1 + 1) + otherChar + theChar);
    wrongAnswers.push((number1) + otherChar + otherChar);
    wrongAnswers.push((number1) + theChar + theChar);
  }
  //Tenth Question type
  if (q.question_key === "AlgebraQ10") {
    const theChar = RandomChar();
    var otherChar = RandomChar();
    while (theChar == otherChar)
      otherChar = RandomChar();
    const number1 = Math.floor(Math.random() * 4 + 2);
    var number2 = Math.floor(Math.random() * 4 + 2);
    while (number1 == number2)
      number2 = Math.floor(Math.random() * 4 + 2);
    questionText = q.question_line_1;
    questionText = questionText.replace('£1&1', number1 + theChar).replace('£2&2', number2 + otherChar);
    correctAnswer = number2 + otherChar + " + " + number1 + theChar;
    wrongAnswers.push(number2 + theChar + " + " + number1 + otherChar);
    wrongAnswers.push(number2 + otherChar + " + " + number2 + theChar);
    wrongAnswers.push(number1 + otherChar + " + " + number2 + otherChar);
  }
  //Eleventh Question type
  if (q.question_key === "AlgebraQ11") {
    const theChar = RandomChar();
    const number1 = Math.floor(Math.random() * 3 + 2);
    var mod = 'double';
    if (number1 == 3)
      mod = 'triple';
    if (number1 == 4)
      mod = 'quadruple';
    const number2 = Math.floor(Math.random() * 10 + 1);
    questionText = q.question_line_1;
    questionText = questionText.replace('*', mod).replace('&', theChar).replace('£', number2);
    correctAnswer = number1 + theChar + " + " + number2;
    wrongAnswers.push((number1 + 1) + theChar + " + " + number2);
    wrongAnswers.push(number1 + theChar + " + " + (number2 + 1));
    wrongAnswers.push((number1 + 1) + theChar + " + " + (number2 + 1));
  }
  //Add the correct answer
  questionAnswers.push({
    correct: true,
    value: correctAnswer
  });
  //Add the wrong answers
  for (var j = 0; j < 3; j++) {
    questionAnswers.push({ correct: false, value: wrongAnswers[j] });
  }

  shuffleArray(questionAnswers);

  console.log(questionText + ": " + correctAnswer);
  let questionObj = {
    question: questionText,
    answers: questionAnswers

  };

  return questionObj;

}
function GetFraction(param)
{
  var bottom, top = 0;
  if (parseInt(param[2]) > 1)
    bottom = parseInt(param[2])
  else
    bottom = Math.floor(param[0] + Math.random() * (param[1] - param[0]));

  top = Math.floor(1 + Math.random() * ((bottom - 1) / 2));

  if (parseInt(param[3]) > 0 && top > parseInt(param[3]))
    top = param[3]

  var frac = [top, bottom];
  return frac;
}

function AddHTML(string)
{
  var newText = string.toString().split(" ");
  for(var i = 0; i < newText.length; i++)
  {
    if(newText[i].includes('/'))
    {
      var tempString = newText[i].split("/");
      newText[i] = "<sup>" + tempString[0] + "</sup>&frasl;<sub>" + tempString[1] + "</sub>";
    }
  }
  return newText.join(" ");
}

function ReturnFractions(q) {
  let generatedCalculation = [];
  let calc = parseInt(q.question_key.toString().replace("FracQ", ""));
  var correctAnswer = "";
  let wrongAnswers = [];

  let questionAnswers = [];

  var tempAnswer = "";
  if (calc <= 4) {
    var frac1, frac2, max, denom;

    //Simple addition
    if (calc === 1) {
      //Create correct Answer
      frac1 = GetFraction([3, 9, 0, 0]);
      frac2 = GetFraction([3, 9, frac1[1], (frac1[1] - frac1[2] - 1)]);
      //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
      tempAnswer = (parseInt(frac1[0]) + parseInt(frac2[0])) + "/" + frac1[1];

      correctAnswer = tempAnswer
      wrongAnswers.push(tempAnswer);

      //Question text =
      generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " + " + frac2[0] + "/" + frac2[1];
      max = frac1[1] + 2;
      denom = frac1[1];
    }
    if (calc === 2) {
      //Create correct Answer
      frac1 = GetFraction([3, 9, 0, 0]);
      frac2 = GetFraction([3, 9, frac1[1], (frac1[1] - frac1[2] - 1)]);

      //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
      tempAnswer = parseInt(frac1[0]) + "/" + frac1[1];
      correctAnswer = tempAnswer
      wrongAnswers.push(tempAnswer);

      //Question text =
      generatedCalculation[0] = (parseInt(frac1[0]) + parseInt(frac2[0])) + "/" + frac1[1] + " - " + frac2[0] + "/" + frac2[1];
      max = frac1[1] + 2;
      denom = frac1[1];
    }
    if (calc === 3) {

      //Create correct Answer
      frac1 = GetFraction([2, 6, 0, 0]);
      frac2 = GetFraction([3, 9, parseInt(frac1[1]) * 2], (frac1[1] - frac1[2] - 1) * 2);
      //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
      tempAnswer = (parseInt(frac1[0]) * 2 + parseInt(frac2[0])) + "/" + frac2[1];
      correctAnswer = tempAnswer
      wrongAnswers.push(tempAnswer);

      //Question text =
      generatedCalculation[0] = (frac1[0]) + "/" + frac1[1] + " + " + frac2[0] + "/" + frac2[1];
      max = frac2[1] + 2;
      denom = frac2[1];
    }
    else if (calc === 4) {

      //Create the question
      frac1 = GetFraction([2, 6, 0, 0]);
      frac2 = GetFraction([3, 9, parseInt(frac1[1]) * 2], (frac1[1] - frac1[2] - 1) * 2);

      //Correct answer is the second fration generated
      //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
      tempAnswer = frac2[0] + "/" + frac2[1];
      correctAnswer = tempAnswer
      wrongAnswers.push(tempAnswer);

      //Question text =
      generatedCalculation[0] = (parseInt(frac1[0]) * 2 + parseInt(frac2[0])) + "/" + frac2[1] + " - " + frac1[0] + "/" + frac1[1];
      max = frac2[1] + 2;
      denom = frac2[1];
    }
    //Create wrong answer
    for (var n = 0; n < 3; n++) {
      do {
        tempAnswer = Math.floor(1 + Math.random() * max) + "/" + denom;
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Adding integers to fractions
  else if (calc == 5) {
    var frac1 = GetFraction([2, 9, 0, 0]);
    var number = Math.floor(2 + Math.random() * 7);

    //Question text =
    generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " + " + number;

    correctAnswer = number + " " + frac1[0] + "/" + frac1[1];
    wrongAnswers.push(correctAnswer);
    for (var n = 0; n < 3; n++) {
      do {
        tempAnswer = (parseInt(number) - 1 + Math.floor(Math.random() * 3)) + " " + Math.floor(1 + Math.random() * frac1[1]) + "/" + (parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3));
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Subtracting fractions from integers
  else if (calc == 6) {
    var frac1 = GetFraction([2, 9, 0, 0]);
    var number = Math.floor(2 + Math.random() * 7);

    //Question text =
    generatedCalculation[0] = number + " - " + frac1[0] + "/" + frac1[1];

    correctAnswer = (parseInt(number) - 1) + " " + (parseInt(frac1[1]) - parseInt(frac1[0])) + "/" + frac1[1];
    wrongAnswers.push(correctAnswer);
    for (var n = 0; n < 3; n++) {
      do {
        tempAnswer = (parseInt(number) - 1 + Math.floor(Math.random() * 3)) + " " + Math.floor(1 + Math.random() * frac1[1]) + "/" + (parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3));
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Subtracting fractions from integers
  else if (calc == 7) {
    var frac1 = GetFraction([2, 6, 0, 0]);
    var divider = Math.floor(2 + Math.random() * 3);
    var base = (parseInt(frac1[1]) * divider);
    //Question text =
    generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " is equivalent to: ?/" + base;

    correctAnswer = (parseInt(frac1[0]) * divider) + "/" + base;
    wrongAnswers.push(correctAnswer);
    for (var n = 0; n < 3; n++) {
      do {
        tempAnswer = Math.floor(Math.random() * parseInt(frac1[1]) * divider) + "/" + base;
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  if (calc === 8) {
    //Create correct Answer
    frac1 = GetFraction([2, 5, 0, 0]);
    frac2 = GetFraction([2, 5, 0, 0]);

    //Question text =
    generatedCalculation[0] = "1/" + frac1[1] + " x " + "1/" + frac2[1];

    //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
    correctAnswer = "1/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
    wrongAnswers.push(correctAnswer);


    for (var n = 0; n < 3; n++) {
      do {
        tempAnswer = "1/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  if (calc === 9) {
    //Create correct Answer
    frac1 = GetFraction([2, 5, 0, 0]);
    frac2 = GetFraction([4, 7, 0, 0]);
    frac2[0] = Math.floor(1 + Math.random() * (frac2[1] - 1));

    //Question text =
    generatedCalculation[0] = "1/" + frac1[1] + " x " + frac2[0] + "/" + frac2[1];

    //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
    correctAnswer = frac2[0] + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
    wrongAnswers.push(correctAnswer);


    for (var n = 0; n < 3; n++) {
      do {
        if (Math.random() > 0.3)
          tempAnswer = frac2[0] + "/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
        else if (Math.random() > 0.5)
          tempAnswer = (frac2[0] * frac1[1]) + "/" + (frac1[0] * frac2[1]);
        else
          tempAnswer = frac2[0] + "/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  if (calc === 10) {
    //Create correct Answer
    frac1 = GetFraction([4, 7, 0, 0]);
    frac2 = GetFraction([4, 7, 0, 0]);

    //Question text =
    generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " x " + frac2[0] + "/" + frac2[1];

    //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
    correctAnswer = (parseInt(frac1[0]) * parseInt(frac2[0])) + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
    wrongAnswers.push(correctAnswer);

    //Wrong answers
    for (var n = 0; n < 3; n++) {
      do {
        if (Math.random() > 0.3)
          tempAnswer = ((parseInt(frac1[0]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[0]) - 1 + Math.floor(Math.random() * 3))) + "/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
        else if (Math.random() > 0.5)
          tempAnswer = (frac2[0] * frac1[1]) + "/" + (frac1[0] * frac2[1]);
        else
          tempAnswer = ((1 + Math.floor(Math.random() * 4)) * (1 + Math.floor(Math.random() * 4))) + "/" + ((4 + Math.floor(Math.random() * 3)) * (4 + Math.floor(Math.random() * 3)));
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Division questions
  if (calc === 11) {
    //generate question
    frac1 = GetFraction([2, 6, 0, 0]);
    frac2 = GetFraction([2, 6, 0, 0]);

    //Question text =
    generatedCalculation[0] = 1 + "/" + frac1[1] + " ÷ " + 1 + "/" + frac2[1];

    //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
    correctAnswer = frac2[1] + "/" + frac1[1];
    wrongAnswers.push(correctAnswer);

    //Wrong answers
    for (var n = 0; n < 3; n++) {
      do {
        if (Math.random() > 0.3)
          tempAnswer = ((parseInt(frac1[0]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[0]) - 1 + Math.floor(Math.random() * 3))) + "/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
        else if (Math.random() > 0.5)
          tempAnswer = (parseInt(frac2[0])) + "/" + (parseInt(frac1[1]));
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Division questions
  if (calc === 12) {
    //generate question
    frac1 = GetFraction([2, 6, 0, 1]);
    frac2 = GetFraction([2, 6, 0, 0]);

    //Question text =
    generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " ÷ " + frac2[0] + "/" + frac2[1];

    //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
    correctAnswer = (frac2[1] * frac1[0]) + "/" + (frac1[1] * frac2[0]);
    wrongAnswers.push(correctAnswer);

    //Wrong answers
    for (var n = 0; n < 3; n++) {
      do {
        if (Math.random() > 0.3)
          tempAnswer = ((parseInt(frac1[0]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[0]) - 1 + Math.floor(Math.random() * 3))) + "/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
        else if (Math.random() > 0.5)
          tempAnswer = (parseInt(frac1[0]) * parseInt(frac2[0])) + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Division questions
  if (calc === 13) {
    //generate question
    frac1 = GetFraction([2, 6, 0, 1]);
    frac1[0] = Math.floor(1 + Math.random() * (frac1[1] - 1));
    frac2 = GetFraction([3, 6, 0, 0]);
    frac2[0] = Math.floor(2 + Math.random() * (frac2[1] - 2));

    //Question text =
    generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " ÷ " + frac2[0] + "/" + frac2[1];

    //"<sup>" + (parseInt(frac1[0]) + parseInt(frac2[0])) + "</sup>&frasl;<sub>" + frac1[1] + "</sub>";
    correctAnswer = (frac2[1] * frac1[0]) + "/" + (frac1[1] * frac2[0]);
    wrongAnswers.push(correctAnswer);

    //Wrong answers
    for (var n = 0; n < 3; n++) {
      do {
        if (Math.random() > 0.3)
          tempAnswer = ((parseInt(frac1[0]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[0]) - 1 + Math.floor(Math.random() * 3))) + "/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)) * (parseInt(frac2[1]) - 1 + Math.floor(Math.random() * 3)));
        else if (Math.random() > 0.5)
          tempAnswer = (parseInt(frac1[0]) * parseInt(frac2[0])) + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Multiply an intiger by a fraction
  if (calc === 14) {
    var frac1 = GetFraction([2, 9, 0, 0]);
    var number = Math.floor(2 + Math.random() * 7);

    //Question text =
    generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " x " + number;

    correctAnswer = (number * frac1[0]) + "/" + frac1[1];
    wrongAnswers.push(correctAnswer);
    for (var n = 0; n < 3; n++) {
      do {
        if (Math.random() > 0.5)
          tempAnswer = (parseInt(number) - 1 + Math.floor(Math.random() * 4)) * frac1[0] + "/" + (parseInt(frac1[1]));
        else
          tempAnswer = parseInt(number) * Math.floor(1 + Math.random() * frac1[0]) + "/" + (parseInt(frac1[1]));
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Divide a integer by a fraction
  if (calc === 15) {
    var frac1 = GetFraction([2, 6, 0, 0]);
    var number = Math.floor(2 + Math.random() * 4);

    //Question text =
    generatedCalculation[0] = number + " ÷ " + frac1[0] + "/" + frac1[1];

    correctAnswer = (number * frac1[1]) + "/" + frac1[0];
    wrongAnswers.push(correctAnswer);
    for (var n = 0; n < 3; n++) {
      do {
        if (Math.random() > 0.5)
          tempAnswer = ((parseInt(number) - 1 + Math.floor(Math.random() * 3)) * frac1[0]) + "/" + frac1[1];
        else
          tempAnswer = (number * Math.floor(1 + Math.random()) * frac1[0]) + "/" + frac1[1];
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Decimals to fractions
  if (calc === 16) {
    var frac1 = GetFraction([2, 6, 0, 0]);
    frac1[0] = Math.floor(1 + Math.random() * (frac1[1] - 1));

    //Question text =
    generatedCalculation[0] = "Convert the following fraction to a decimal number: " + frac1[0] + "/" + frac1[1];

    correctAnswer = parseInt(frac1[0]) / parseInt(frac1[1]);
    correctAnswer = correctAnswer.toString().substr(0, 4);
    wrongAnswers.push(correctAnswer);
    for (var n = 0; n < 3; n++) {
      do {
        if (Math.random() > 0.5)
          tempAnswer = ((parseInt(frac1[0]) - 1 + Math.floor(Math.random() * 3))) / frac1[1];
        else
          tempAnswer = frac1[0] / (frac1[1] - 1 + Math.floor(Math.random() * 3));
        tempAnswer = tempAnswer.toString().substr(0, 4);
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Fractions to percentages
  if (calc === 17) {
    var frac1 = GetFraction([2, 6, 0, 0]);
    frac1[0] = Math.floor(1 + Math.random() * (frac1[1] - 1));

    //Question text =
    generatedCalculation[0] = "Convert the following fraction to a percentage: " + frac1[0] + "/" + frac1[1];

    correctAnswer = parseInt(frac1[0]) / parseInt(frac1[1]);
    correctAnswer = (parseFloat(correctAnswer.toString().substr(0, 4)) * 100.0) + "%";
    wrongAnswers.push(correctAnswer);
    for (var n = 0; n < 3; n++) {
      do {
        if (Math.random() > 0.5)
          tempAnswer = ((parseInt(frac1[0]) - 1 + Math.floor(Math.random() * 3))) / frac1[1];
        else
          tempAnswer = frac1[0] / (frac1[1] - 1 + Math.floor(Math.random() * 3));
        tempAnswer = (parseFloat(tempAnswer.toString().substr(0, 4)) * 100) + "%";
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Decimals to fractions
  if (calc === 18) {
    var frac1 = GetFraction([2, 6, 0, 1]);

    var temp = parseInt(frac1[0]) / parseInt(frac1[1]);
    temp = temp.toString().substr(0, 4);

    //Question text =
    generatedCalculation[0] = "Convert the following decimal to a fraction: " + temp;

    correctAnswer = frac1[0] + "/" + frac1[1];
    wrongAnswers.push(correctAnswer);

    for (var n = 0; n < 3; n++) {
      do {
        if (Math.random() > 0.5)
          tempAnswer = "1/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)));
        else
          tempAnswer = "1/" + (Math.floor(Math.random() * 6));
      } while (wrongAnswers.includes(tempAnswer) === true || tempAnswer === "1/0" || tempAnswer === "1/1")
      wrongAnswers.push(tempAnswer);
    }
  }
  //Decimals to percentages
  if (calc === 19) {
    var num = (0.1 + Math.random() * 0.9).toString().substr(0, 4);
    generatedCalculation[0] = "Convert the following decimal to a percentage: " + num;
    correctAnswer = Math.round(parseFloat(num) * 100) + "%";
    wrongAnswers.push(correctAnswer);
    var divider = 1;
    for (var n = 0; n < 3; n++) {
      do {
        tempAnswer = (parseFloat(num) * divider).toString().substr(0, 4) + "%";
        divider = divider * 10;
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Percentages to fractions
  if (calc === 20) {
    var frac1 = GetFraction([2, 6, 0, 1]);

    var temp = parseInt(frac1[0]) / parseInt(frac1[1]);
    temp = Math.round(parseFloat(temp.toString().substr(0, 4)) * 100) + "%";

    //Question text =
    generatedCalculation[0] = "Convert the following decimal to a fraction: " + temp;

    correctAnswer = frac1[0] + "/" + frac1[1];
    wrongAnswers.push(correctAnswer);

    for (var n = 0; n < 3; n++) {
      do {
        if (Math.random() > 0.5)
          tempAnswer = "1/" + ((parseInt(frac1[1]) - 1 + Math.floor(Math.random() * 3)));
        else
          tempAnswer = "1/" + (Math.floor(Math.random() * 6));
      } while (wrongAnswers.includes(tempAnswer) === true || tempAnswer === "1/0" || tempAnswer === "1/1")
      wrongAnswers.push(tempAnswer);
    }
  }
  //Percentages to deciamals
  if (calc === 21) {
    var num = (0.1 + Math.random() * 0.9).toString().substr(0, 4);
    generatedCalculation[0] = "Convert the following percentage to a decimal: " + Math.round(parseFloat(num) * 100) + "%";
    correctAnswer = num;
    wrongAnswers.push(correctAnswer);
    var divider = 1000;
    for (var n = 0; n < 3; n++) {
      do {
        tempAnswer = (parseFloat(num) * divider).toString().substr(0, 4);
        divider = divider / 10;
      } while (wrongAnswers.includes(tempAnswer) === true)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Rounding decimals to 1dp
  if (calc === 22) {
    var wholeNum = GenerateRandom(1,8);
    var dec1Number = Math.round(GenerateRandom(10,80)/10)*10;
    var dec2Number = GenerateRandom(1,9);
    var num = parseFloat((wholeNum + (dec1Number/100)+(dec2Number/100)).toFixed(2));
    generatedCalculation[0] = "Round the following number to 1 decimal place: " + num;

    correctAnswer = Math.round(num * 10) / 10;
    wrongAnswers.push(correctAnswer);
    tempAnswer = Math.round((correctAnswer + 0.1) * 10) / 10;
    wrongAnswers.push(tempAnswer);
    tempAnswer = Math.round((correctAnswer - 0.1) * 10) / 10;
    wrongAnswers.push(tempAnswer);
    tempAnswer = (Math.round((num * 10) * 10) / 10).toString().substr(1);
    wrongAnswers.push(tempAnswer);
  }
  //Rounding decimals to 2dp
  if (calc === 23) {
    var wholeNum = GenerateRandom(1,8);
    var dec1Number = Math.round(GenerateRandom(10,80)/10)*10;
    var dec2Number = GenerateRandom(1,8);
    var dec3Number = GenerateRandom(1,9);
    var num = parseFloat((wholeNum + (dec1Number/100)+(dec2Number/100)+(dec3Number/1000)).toFixed(3));
    generatedCalculation[0] = "Round the following number to 2 decimal places: " + num;

    correctAnswer = Math.round(num * 100) / 100;
    wrongAnswers.push(correctAnswer);
    tempAnswer = Math.round((correctAnswer + 0.01) * 100) / 100;
    wrongAnswers.push(tempAnswer);
    tempAnswer = Math.round((correctAnswer - 0.01) * 100) / 100;
    wrongAnswers.push(tempAnswer);
    tempAnswer = (Math.round((num * 10) * 100) / 100).toString().substr(1);
    wrongAnswers.push(tempAnswer);
  }
  //Adding decimals
  if (calc === 24) {
    var dec1 = (0.11 + Math.random() * 0.34).toString().substr(0, 4);
    var dec2 = (0.11 + Math.random() * 0.34).toString().substr(0, 4);
    var answer = parseFloat(dec1) + parseFloat(dec2);
    answer = Math.round(answer * 100) / 100;
    generatedCalculation[0] = dec1 + " + " + dec2 + " = ";
    correctAnswer = answer;
    wrongAnswers.push(correctAnswer);

    for (var n = 0; n < 3; n++) {
      do {
        tempAnswer = (parseFloat(correctAnswer) + (Math.random() * 0.5 - 0.25)).toString().substr(0, 4);;
      } while (wrongAnswers.includes(tempAnswer) === true || parseFloat(tempAnswer) <= 0 || parseFloat(tempAnswer) >= 1)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Subracting decimals
  if (calc === 25) {
    var dec1 = (0.61 + Math.random() * 0.34).toString().substr(0, 4);
    var dec2 = (0.11 + Math.random() * 0.3).toString().substr(0, 4);
    var answer = parseFloat(dec1) - parseFloat(dec2);
    answer = Math.round(answer * 100) / 100;
    generatedCalculation[0] = dec1 + " - " + dec2 + " = ";
    correctAnswer = answer;
    wrongAnswers.push(correctAnswer);

    for (var n = 0; n < 3; n++) {
      do {
        tempAnswer = (parseFloat(correctAnswer) + (Math.random() * 0.5 - 0.25)).toString().substr(0, 4);;
      } while (wrongAnswers.includes(tempAnswer) === true || parseFloat(tempAnswer) <= 0 || parseFloat(tempAnswer) >= 1)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Multiplying decimals
  if (calc === 26) {
    let options = [0.2, 0.25, 0.4, 0.5, 0.75];
    var dec1 = options[Math.floor(Math.random() * options.length)];
    var dec2 = (0.4 + Math.random() * 0.3).toString().substr(0, 3);
    var answer = parseFloat(dec1) * parseFloat(dec2);
    answer = Math.round(answer * 100) / 100;
    generatedCalculation[0] = dec1 + " x " + dec2 + " = ";
    correctAnswer = answer;
    wrongAnswers.push(correctAnswer);

    for (var n = 0; n < 3; n++) {
      do {
        tempAnswer = (parseFloat(correctAnswer) + (Math.random() * 0.5 - 0.25)).toString().substr(0, 4);;
      } while (wrongAnswers.includes(tempAnswer) === true || parseFloat(tempAnswer) <= 0 || parseFloat(tempAnswer) >= 1)
      wrongAnswers.push(tempAnswer);
    }
  }
  //Dividing integers by decimals
  if (calc === 27) {
    let options = [0.25, 0.5, 0.2];
    var dec1 = options[Math.floor(Math.random() * options.length)];
    var dec2 = Math.round(1 + Math.random() * 5);
    var answer = parseInt(dec2) / parseFloat(dec1);
    answer = Math.round(answer * 100) / 100;
    generatedCalculation[0] = dec2 + " ÷ " + dec1 + " = ";
    correctAnswer = answer;
    wrongAnswers.push(correctAnswer);

    for (var n = 0; n < 3; n++) {
      do {
        tempAnswer = (parseFloat(correctAnswer) + Math.round(Math.random() * 15) - 7);
      } while (wrongAnswers.includes(tempAnswer) === true || parseFloat(tempAnswer) <= 0)
      wrongAnswers.push(tempAnswer);
    }
  }
  if (calc == 28){//percentage of a number
    var perc = GenerateRandom(1,99);
    var number = GenerateRandom(1,9)*100;
    var answer = (number/100)*perc ;
    generatedCalculation[0] = "What is "+perc+"% of "+number+" ?";
    correctAnswer = answer;
    wrongAnswers.push(correctAnswer);

    for (var n = 0; n < 3; n++)
    {
      tempAnswer = correctAnswer + GenerateUniqueRandom(-5,5,wrongAnswers);
      wrongAnswers.push(tempAnswer);
    }
    console.log(wrongAnswers);
  }
  if (calc == 29) {//adding mixed numbers
    var num1 = GenerateRandom(1, 9);
    var f1bottom = GenerateRandom(2, 5);
    var f2bottom = f1bottom * 2;
    var f1top = GenerateRandom(1, f1bottom);
    var f2top = GenerateRandom(2, f2bottom);
    var ans;
    var ansInt = num1;

    //calc answer
    if (((f1top * 2) + f2top) == f2bottom) {
      console.log("you right");
      console.log(f2top);
      f2top = f2top-1;
      console.log(f2top);
      ans = (f1top * 2) + f2top;
    }
    else if (((f1top * 2) + f2top) > f2bottom) {
      ansInt = ansInt+1;
      ans = ((f1top * 2) + f2top) - f2bottom;
    }
    else {
      ans = (f1top * 2) + f2top;
    }
    console.log(ans);

    generatedCalculation[0] = num1 + " " + f1top + "/" + f1bottom + " + " + f2top + "/" + f2bottom + " = " + ansInt + " " + "?/"+f2bottom;
    correctAnswer = ans;

    wrongAnswers.push(correctAnswer);

    for (var n = 0; n < 3; n++)
    {
      tempAnswer = GenerateUniqueRandom(correctAnswer-5,correctAnswer+5,wrongAnswers);
      wrongAnswers.push(tempAnswer);
    }
    console.log(wrongAnswers);
  }

  if (calc == 30) {//subtracting mixed numbers

    //generate fractions
    var num1 = GenerateRandom(1, 9);
    var f1bottom = GenerateRandom(2, 5);
    var f2bottom = f1bottom * 2;
    var f1top = GenerateRandom(1, f1bottom);
    var f2top = GenerateRandom(1, f2bottom);
    var ans;
    var ansInt = num1;

    //calc answer
    if (((f1top * 2) - f2top) == 0) {
      f2top = f2top-1;
      ans = (f1top * 2) - f2top;
    }
    else if (((f1top * 2) - f2top) < 0) {
      ansInt = ansInt-1;
      ans = f2bottom - (f2top - (f1top * 2));
    }
    else {
      ans = (f1top * 2) - f2top;
    }
    console.log(ans);

    generatedCalculation[0] = num1 + " " + f1top + "/" + f1bottom + " - " + f2top + "/" + f2bottom + " = " + ansInt + " " + "?/"+f2bottom;
    correctAnswer = ans;

    wrongAnswers.push(correctAnswer);

    for (var n = 0; n < 3; n++)
    {
      tempAnswer = GenerateUniqueRandom(correctAnswer-5,correctAnswer+5,wrongAnswers);
      wrongAnswers.push(tempAnswer);
    }
    console.log(wrongAnswers);
  }

  let questionText = generatedCalculation.join(" ");
  questionText = AddHTML(questionText);
  //let correctAnswer = getAnswer(generatedCalculation);
  console.log(q);
  console.log(wrongAnswers);
  for (var n = 0; n < 4; n++) {
    questionAnswers.push({
      correct: n === 0,
      value: AddHTML(wrongAnswers[n].toString())
    });
  }

  shuffleArray(questionAnswers);

  let questionObj = {
    question: questionText,
    answers: questionAnswers,
    subject: "fractions"
  };

  return questionObj;
}

function ReturnFormattedQuestion(question, subjectName) {
  //do it for each one
  console.log(subjectName);
  console.log(question)
  var formattedQuestion;
  //then generate the actual question
  if (subjectName == "add") {
    formattedQuestion = ReturnAddition(question);
    console.log(formattedQuestion);
  }
  if (subjectName == "geo") {
    formattedQuestion = ReturnGeometry(question);
    console.log(formattedQuestion);
  }
  if (subjectName == "meas") {
    formattedQuestion = ReturnMeasurements(question);
    console.log(formattedQuestion);
  }

  if (subjectName == "mult") {
    formattedQuestion = ReturnMultiplication(question);
    console.log(formattedQuestion);
  }
  if (subjectName == "numb") {
    formattedQuestion = ReturnNumberPlace(question);
    console.log(formattedQuestion);
  }
  if (subjectName == "stats") {
    formattedQuestion = ReturnStats(question);
    console.log(formattedQuestion);
  }

  if (subjectName == "algebra") {
    formattedQuestion = ReturnAlgebra(question);
    console.log(formattedQuestion);
  }

  if (subjectName == "fractions") {
    formattedQuestion = ReturnFractions(question);
    console.log(formattedQuestion);
  }

  formattedQuestion.topic_key = question.topic_key;
  formattedQuestion.category = question.category;
  return formattedQuestion;
}

function GetSubjectName(diff, sub) {
  console.log("------------------------------------------------------------------------------------")

  console.log("Diff  = " + diff);
  console.log("SubID = " + sub);
  var subName = "";
  if (sub == 0) {
    subName = "add";
  }
  if (diff >= 2 && sub == 1) {
    subName = "fractions"
  }
  if ((diff < 2 && sub == 1) || (diff >= 2 && sub == 2)) {
    subName = "geo";
  }
  if ((diff < 2 && sub == 2) || (diff >= 2 && sub == 3)) {
    subName = "meas";
  }
  if ((diff < 2 && sub == 3) || (diff >= 2 && sub == 4)) {
    subName = "mult";
  }
  if ((diff < 2 && sub == 4) || (diff >= 2 && sub == 5)) {
    subName = "numb";
  }
  if ((diff < 5 && sub == 6) || (diff >= 5 && sub == 7)) {
    subName = "stats";
  }
  if (diff >= 5 && sub == 6) {
    subName = "algebra"
  }
  return subName;
}



export default function Intervention({ ...props }) {
  const game = useGame(props.game.id);
  console.log(game.game_type);
  const { questions } = useIntervention({ game_type: game.game_type }, game);
  const [levels, setLevels] = useState();
  //console.log("Questions");
  //console.log(questions);

  // once the questions have been retrieved we then generate the questionlist for the rating game
  useEffect(() => {
    if (questions !== undefined) {
      var q = questions;
      console.log(q);
      console.log(questions);
      console.log(questions.length)
      console.log(Object.keys(questions).length);
      console.log(Object.keys(questions));
      var questionArray = Object.values(questions);
      var temp = []
      console.log(questionArray);
      let realQuestions = [];

      //for each difficulty
      for (let diff = 0; diff < questionArray.length; diff++) {
        //console.log(questionArray[diff]);
        var subjectArray = Object.values(questionArray[diff])
        console.log(subjectArray);
        //for each subject in that difficulty
        var diffArray = [];
        var subArray = [];
        for (let subject = 0; subject < subjectArray.length; subject++) {
          subArray = [];
          //console.log(subjectArray[subject]);
          //for each question in the subject
          for (let q = 0; q < subjectArray[subject].length; q++) {
            //gets subject name based on how many subjects are in
            var subName = GetSubjectName(diff, subject);
            //issue with later stages having more subjects than earlier stages
            //add each question / format each question
            let real = ReturnFormattedQuestion(subjectArray[subject][q], subName);
            if (real != null)
              console.log(real);
            //questionArray[diff][subject] = realQuestion;
            subArray.push(real);
          }
          diffArray.push(subArray);
        }
        realQuestions.push(diffArray);
      }
      console.log(realQuestions[0])
      console.log(realQuestions[1])
      console.log(realQuestions.length);
      console.log(realQuestions);
      setLevels(realQuestions);
      //console.log(questionArray);
    }
  }, [questions]);

  return levels !== undefined ? (
    <InterventionGame
      questionslist={levels}
      onBack={() => {
        navigate(`/games/`);
      }}
      game={game}
      homework_id={props.homework_id}
    />
  ) : (
      <LoadingScreen />
    );
}


